export default {
  "Student Login": "學生登入",
  "Business Login": "商戶登入",
  "Forgot Password?": "忘記密碼？",
  "Forgot Password": "忘記密碼",
  "Enter the email address linked to your account and we will send you a verification code.":
    "請輸入帳戶綁定的電郵地址，我們會發送驗證碼給你。",
  "SEND VERIFICATION CODE": "發送驗證碼",
  "VERIFY CODE": "確認驗證碼",
  "Choose a password with at least 8 characters.":
    "請設定至少 8 個字元的密碼。",
  "Confirm New Password": "確認新密碼",
  "RESET PASSWORD": "重設密碼",
  "Password reset successfully": "密碼重設成功",
  "Back to login": "返回登入",
  "signup.emailExisted": "電郵已存在",
  "signup.usernameExisted": "用戶名已存在",
  "signup.invalidUniversityEmail": "無效的大學電郵",
  "signup.phoneExists": "此電話號碼已由其他帳戶使用，請改用其他號碼。",
  "signup.phoneRequired": "請輸入電話號碼。",
  "signup.invalidPhone": "電話號碼格式無效，請檢查號碼及國際區碼後再試一次。",
  "signup.hkPhoneMustBe8Digits": "香港電話號碼須為 8 位數字（例如 9123 4567），請檢查號碼後再試一次。",
  "signup.smsSendFailed": "無法發送驗證簡訊，請檢查號碼後再試一次。",
  "My Coupons": "我的優惠券",
  "Create New Coupon": "建立新優惠券",
  "No coupons": "沒有優惠券",
  Search: "搜尋",
  Account: "帳戶",
  Guest: "訪客",
  "Create an account to join, save events, follow societies, share surveys and more?":
    "建立帳戶以加入、儲存活動、關注社團、分享問卷等？",
  "LOG IN NOW": "立即登入",
  "REGISTER NOW": "立即註冊",
  Username: "用戶名",
  "Your University Email": "你的大學電郵",
  "Phone Number": "電話號碼",
  "Region Code": "地區號碼",
  "Select your Region Code": "選擇你的地區號碼",
  Password: "密碼",
  "Confirmed Password": "確認密碼",
  REGISTER: "註冊",
  "ALREADY HAVE AN ACCOUNT?": "已經有帳戶？",
  "Redeem Times per coupon": "每張優惠券可兌換次數",
  "Issued Quantity": "發行數量",
  "Redeem Times & Issued Quantity": "兌換次數及發行數量",
  "Offer Details": "優惠詳情",
  "Generated Terms": "自動生成條款",
  "Preview Terms & Conditions": "預覽條款及細則",
  "Please fill in Offer Details": "請完成下方的優惠詳情部分。",
  "Extra Terms (Optional)": "額外條款（可選）",
  "Free Shipping has no extra details": "免運費無額外詳情",
  "Cashback amount": "現金回贈金額",
  "Free Item Details": "免費贈品詳情",
  "Bundle / Package": "組合/套裝",
  "Bundle Details": "組合詳情",
  "Time-slot Deal": "時段優惠",
  "Time-slot Deal Details": "時段優惠詳情",
  "Group Deal": "團體優惠",
  "Minimum people": "最少人數",
  "Group Deal Details": "團體優惠詳情",
  "Reservation Discount": "預約折扣",
  "Advance booking days": "提前預約天數",
  "Reservation Discount Details": "預約折扣詳情",
  "Free Upgrade": "免費升級",
  "Free Upgrade Details": "免費升級詳情",
  "Add-on Deal": "加購優惠",
  "Add-on Deal Details": "加購優惠詳情",
  "Points Multiplier": "積分倍增",
  "Birthday Special": "生日優惠",
  "Birthday Special Details": "生日優惠詳情",
  "Deposit Waiver": "免按金",
  "Deposit Waiver Details": "免按金詳情",
  "First-time Deal": "首次優惠",
  "First-time Deal Details": "首次優惠詳情",
  Terms_Discount_Percent: "{{value}}% 折扣",
  Terms_Discount_Amount: "減免HK${{value}}",
  Terms_Cashback_Percent: "{{value}}% 現金回贈",
  Terms_Cashback_Amount: "HK${{value}} 現金回贈",
  Terms_BOGO: "買{{buy}}送{{get}}",
  Terms_FreeItem: "免費贈品：{{detail}}",
  Terms_FreeShipping: "免運費",
  Terms_Bundle: "組合優惠：{{detail}}",
  Terms_TimeSlotDeal: "{{start}}–{{end}} 有效：{{detail}}",
  Terms_GroupDeal: "{{min}}人或以上團體：{{detail}}",
  Terms_ReservationDiscount: "提前{{days}}天預約：{{detail}}",
  Terms_FreeUpgrade: "免費升級：{{detail}}",
  Terms_AddOn: "加購優惠：{{detail}}",
  Terms_PointsMultiplier: "{{multiplier}}倍積分",
  Terms_Birthday: "生日優惠：{{detail}}",
  Terms_DepositWaiver: "免按金：{{detail}}",
  Terms_FirstTime: "首次優惠：{{detail}}",
  Terms_ExpiryDate: "到期日：{{date}}",
  Terms_ExpiryPeriodDays: "有效期{{days}}天",
  Terms_UninfohkOfficialLaw:
    "所有條款及最終解釋權歸UninfoHK所有。如有任何爭議，UninfoHK保留最終決定權。本優惠受香港特別行政區適用法律及法規約束。",
  "Expiry Date": "到期日",
  "Expiry Period (days)": "有效期（天）",
  "Original Price": "原價",
  "Original Price (HKD)": "原價（港幣）",
  "Offer suspended": "優惠已暫停",
  "This offer is suspended and cannot be redeemed right now.":
    "此優惠已暫停，目前不可兌換。",
  "Coupon Price": "優惠券價格",
  "Coupon Discount Price": "優惠券折扣價",
  "Coupon Name": "優惠券名稱",
  "Coupon Terms": "優惠券條款",
  "How to use": "使用方法",
  "Maximum limit (Optional)": "最大限制（可選）",
  "Coupon Information": "優惠券資訊",
  "Please Try Again": "請重試",
  "Can't Update Access Token": "無法更新存取權杖",
  "Email Existed": "電郵已存在",
  "Username Existed": "用戶名已存在",
  "Can't Register Account": "無法註冊帳戶",
  "Email Not Registered": "電郵未註冊",
  "Invalid Password": "密碼無效",
  "Account Is Not Active": "帳戶未啟用",
  // Sent by the server as the -40022 chat-send-denial / auto-sign-out message.
  "Business account is not active": "商業帳戶未啟用",
  "Can`t Upload Event": "無法上傳活動",
  "Can`t Unsubscript Event": "無法取消訂閱活動",
  "Can`t Follow Organizer": "無法關注主辦方",
  "Can`t Unfollow Organizer": "無法取消關注主辦方",
  "Can`t Redeem Coupon": "無法兌換優惠券",
  "Not Enough Coupon To Redeem": "可兌換優惠券數量不足",
  ACCEPT: "接受",
  "ACCEPT TASKS NOW": "立即接受任務",
  ACCEPTED: "已接受",
  ADD: "新增",
  "ADD MEMBER": "新增成員",
  "ADD QUESTION": "新增問題",
  "ADD TASKS NOW": "立即新增任務",
  "APPLICATION DEADLINE - ": "申請截止 - ",
  ASSIGN: "指派",
  "Accept The Tasks?": "接受任務？",
  "Activity Description": "活動描述",
  "Activity Description*": "活動描述*",
  Description: "描述",
  "Activity Location": "活動地點",
  "Activity Photo": "活動照片",
  Add: "新增",
  "Add Tag for the activity (It will assigned to the elements that you want to search with)":
    "為活動新增標籤（將分配給你想搜尋的元素）",
  All: "全部",
  "Application Deadline: ": "申請截止：",
  "Application Rejected": "申請被拒絕",
  "Assignt Tasks Now": "立即指派任務",
  "BACHELOR DEGREE": "學士學位",
  "Basic Information": "基本資料",
  CANCEL: "取消",
  COMPLETE: "完成",
  COMPLETED: "已完成",
  CONFIRM: "確認",
  CONTINUE: "繼續",
  "CREATE NOW": "立即建立",
  "Camera permission is required.": "需要相機權限。",
  "Can`t Accept Sponsor Tasks": "無法接受贊助任務",
  "Can`t Assign Sponsor Tasks To Society": "無法指派贊助任務給社團",
  "Can`t Change Password": "無法更改密碼",
  "Can`t Complete All Sponsor Tasks": "無法完成所有贊助任務",
  "Can`t Complete Sponsor Task": "無法完成贊助任務",
  "Can`t Create Sponsor Activity": "無法建立贊助活動",
  "Can`t Create Survey": "無法建立問卷",
  "Can`t Delete Event": "無法刪除活動",
  "Can`t Edit Event": "無法編輯活動",
  "Can`t Edit Profile": "無法編輯個人資料",
  "Can`t Get Chat Room": "無法獲取聊天室",
  "Can`t Get Organizer": "無法獲取主辦方",
  "Can`t Get Score": "無法獲取分數",
  "Can`t Get Society Members": "無法獲取社團成員",
  "Can`t Get User": "無法獲取用戶",
  "Can`t Give Rewards": "無法發放獎勵",
  "Can`t Join Event": "無法參加活動",
  "Can`t Redeem Sponsor": "無法兌換贊助",
  "Can`t Remove Society Member": "無法移除社團成員",
  "Can`t Unjoin Event": "無法取消參加活動",
  "Can`t Upload Sponsor Tasks Prove": "無法上傳贊助任務證明",
  "Can`t Use Redeemed Coupons": "無法使用已兌換的優惠券",
  Chat: "聊天",
  "Chinese Names": "中文名稱",
  "Coupon Does Not Belong To This Account": "此優惠券不屬於此帳戶",
  "Create Activity": "建立活動",
  "Create Activity Now !!!": "立即建立活動！！！",
  Created: "已建立",
  "Custom Repeat": "自訂重複",
  DashBoard: "儀表板",
  Date: "日期",
  "Deadline Date & Time*": "截止日期及時間*",
  "Description for the First Number": "第一個數字的描述",
  "Description for the Second Number": "第二個數字的描述",
  "Don`t repeat": "不重複",
  EDIT: "編輯",
  EMAIL: "電郵",
  "EVENT ENDED": "活動已結束",
  Edit: "編輯",
  Email: "電郵",
  "End Date": "結束日期",
  "End Time": "結束時間",
  "Enhance the allure of this survey by penning down your desired reward.":
    "填寫你想要的獎勵以提升問卷吸引力。",
  FILTER: "篩選",
  FINISH: "完成",
  Fee: "費用",
  "Fill in your option": "填寫你的選項",
  Free: "免費",
  GENDER: "性別",
  Give: "給予",
  "Grant Permission": "授權",
  "HIDE EVENT TARGET": "隱藏活動對象",
  "HashTag (max 20.)": "標籤（最多20個）",
  IDENTITY: "身份",
  "Infinity Quantity": "無限數量",
  "Invalid New Password": "新密碼無效",
  JOIN: "加入",
  Join: "加入",
  "Join Activity": "參加活動",
  "Join Activity Now !!!": "立即參加活動！！！",
  Joining: "加入中",
  Link: "連結",
  "Location*": "地點*",
  Login: "登入",
  "MORE DETAILS": "更多詳情",
  "Max Participants": "最多參加人數",
  "Max Participants*": "最多參加人數*",
  "Meeting Date & Time*": "會議日期及時間*",
  "Meeting Date: ": "會議日期：",
  "Meeting Location": "會議地點",
  "Meeting Location*": "會議地點*",
  "No Any Incompleted Sponsor Tasks": "沒有任何未完成的贊助任務",
  "No Participants": "沒有參加者",
  Notification: "通知",
  "Once you accept the tasks. You must complete the tasks": "一旦接受任務，你必須完成任務",
  "Once you click complete the task. You cannot return your action":
    "一旦點擊完成任務，無法撤回操作",
  "Owner of the email (optional)": "電郵擁有者（可選）",
  "Owner of the phone number (optional)": "電話號碼擁有者（可選）",
  POINTS: "積分",
  "People Joined": "已加入人數",
  Phone: "電話",
  "Phone number": "電話號碼",
  "Please Accept The Tasks": "請接受任務",
  "Please Complete The Tasks": "請完成任務",
  "Please Fill In Title": "請填寫標題",
  "Please Input Phone Number": "請輸入電話號碼",
  "Please Input Tag": "請輸入標籤",
  "Please Select Event End Date": "請選擇活動結束日期",
  "Please Select Event Start Date": "請選擇活動開始日期",
  "Please upload images as verification of the completed task":
    "請上傳作為任務完成證明的圖片",
  "Please use university email": "請使用大學電郵",
  Quantity: "數量",
  "Quantity Of Sponsors": "贊助數量",
  "Quantity*": "數量*",
  "REDEEM COUPONS": "兌換優惠券",
  REJECT: "拒絕",
  REJECTED: "已拒絕",
  REMOVE: "移除",
  "Redeem Point*": "兌換積分*",
  "Redeem Poiunt": "兌換積分",
  "Redeem to get Promo Code \\n\\n": "兌換以獲取推廣碼\n\n",
  "Redeemed Coupon Not Existed": "已兌換的優惠券不存在",
  "Redeemed Coupon Was Used": "已兌換的優惠券已被使用",
  "Remove the task?": "移除任務？",
  "SHOW EVENT TARGET": "顯示活動對象",
  START: "開始",
  "Search for users (optional)": "搜尋用戶（可選）",
  "Select your University": "選擇你的大學",
  "Select your Year Of Study": "選擇你的就讀年級",
  "Select your year of study": "選擇你的就讀年級",
  Signup: "註冊",
  "Start Date": "開始日期",
  "Start Time": "開始時間",
  Statistics: "統計",
  Subscripted: "已訂閱",
  "Survey Targets": "問卷對象",
  "TASK COMPLETED": "任務已完成",
  Tag: "標籤",
  "Target Gender": "目標性別",
  "Target Identity": "目標身份",
  Task: "任務",
  "Task Completed": "任務已完成",
  "Task completed?": "任務完成？",
  "Tasks Accepted": "已接受任務",
  "Tasks Assigned": "已指派任務",
  "Tasks Completed": "已完成任務",
  Title: "標題",
  "Title of the link (optional)": "連結標題（可選）",
  UNIVERSITY: "大學",
  UNJOIN: "取消加入",
  UPDATE: "更新",
  USED: "已使用",
  USERNAME: "用戶名",
  "Uninfo will verify your university card in 24 hrs": "Uninfo會在24小時內驗證你的學生證",
  "University Email": "大學電郵",
  "Upload Prove Now": "立即上傳證明",
  "Uploaded Prove": "已上傳證明",
  "User Can Only Redeem The Coupon Once": "用戶每張優惠券僅可兌換一次",
  "User Is Not Existerd": "用戶不存在",
  "Wait For Soceity": "等待社團",
  "Wait For Tasks": "等待任務",
  "YEAR OF STUDY": "就讀年級",
  "Year Of Study": "就讀年級",
  YearOfStudy: "就讀年級",
  choose: "選擇",
  email: "電郵",
  please_fill_in_all_the_blank: "請填寫所有空格",
  please_try_again: "請重試",
  s: "秒",
  upload_poster: "上傳海報",
  "MONTHLY STATEMENT": "每月結算報表",
  Year: "年份",
  "Platform Fee": "平台費用",
  "Total Fees": "總費用",
  "What you're paying for": "你的費用明細",
  "Coupon Shortfall": "優惠券不足費用",
  "Platform fee (free first year)": "平台費用（首年免費）",
  "No charge yet — assessed after the month ends": "尚未收費 — 月結後才評估",
  "{{count}} of {{required}} new coupon required — charged in {{month}}": "{{count}}/{{required}} 張新優惠券未達標 — 將於 {{month}} 收費",
  "{{count}} of required new coupon published": "已發布 {{count}} 張所需的新優惠券",
  "Free first year (First 100)": "首100間商家 首年免費",
  "until {{date}}": "至 {{date}}",
  "Monthly plan": "月繳計劃",
  "Yearly plan": "年繳計劃",
  "Renewal cancelled": "已取消自動續期",
  Manage: "管理",
  "Coupons Used": "已使用優惠券",
  "Coupons Redeemed": "已兌換優惠券",
  Payment: "付款",
  "Pay by Bank Transfer": "銀行轉帳付款",
  "Pay by PayMe": "以PayMe付款",
  "Bank Name": "銀行名稱",
  "Account Name": "帳戶名稱",
  "Account Number": "帳戶號碼",
  "Tap any field to copy": "點擊任意欄位以複製",
  Copied: "已複製",
  "Copy PayMe Link": "複製PayMe連結",
  "PayMe is not configured": "尚未設定PayMe",
  Expand: "展開",
  Collapse: "收起",
  "Copy Receipt Link": "複製收據連結",
  "No receipt uploaded": "尚未上傳收據",
  "Receipt uploaded": "收據已上傳",
  "Receipt upload failed": "收據上傳失敗",
  "Uploading...": "上傳中...",
  "Please enable photo access": "請啟用照片存取權限",
  "Please select an image": "請選擇圖片",
  Month: "月份",
  "No statement for this month": "本月無結算報表",
  "This feature is for business accounts only": "此功能僅限商戶帳戶使用",
  "Can`t Fetch Monthly Statement": "無法獲取月結單",
  Record: "紀錄",
  "Business: scan customer coupon": "商戶：掃描顧客優惠券",
  "User: scan to redeem coupon": "用戶：掃描以兌換優惠券",
  "Scan customer coupon QR to use": "掃描顧客優惠券二維碼以使用",
  "Scan QR to redeem coupon": "掃描二維碼兌換優惠券",
  "Ask customer to show QR": "請顧客出示二維碼",
  "After success, coupon will be used": "成功後優惠券將被使用",
  "After success, points will be deducted": "成功後積分將被扣除",
  "Scan QR Code": "掃描二維碼",
  "Align QR code within frame": "請將二維碼對準框內",
  "Only partner shops can scan this QR code": "僅合作商戶可掃描此二維碼。",
  "This QR code must be scanned by a partner shop": "掃描以使用。此二維碼僅限合作商戶掃描。",
  "Business Email": "商戶電郵",
  Coupon: "優惠券",
  "No sponsors": "暫無贊助商",
  "Sponsors are set up by UninfoHK.": "贊助商由 UninfoHK 設置。",
  "Sponsors are managed by UninfoHK.": "贊助商由 UninfoHK 管理。",
  "Sponsor the community with UninfoHK": "與 UninfoHK 一起贊助社群",
  "Chat with UninfoHK to learn how to sponsor the community and promote your brand.":
    "與 UninfoHK 聊天，了解如何贊助社群並推廣您的品牌。",
  "Log in with an authorized account to view this section, or chat with us to request a sponsor.":
    "請以已授權的帳戶登入以查看此部分，或與我們聊天申請贊助。",
  "Chat with UninfoHK": "與 UninfoHK 聊天",
  "Want to sponsor students?": "想贊助學生嗎？",
  "Chat with UninfoHK to request a sponsor. Tell us what you'd like to sponsor and the tasks students should complete.":
    "與 UninfoHK 聊天以申請贊助商。請告訴我們您想贊助什麼，以及希望學生完成的任務。",
  "UninfoHK sets up the sponsor and assigns it to your account. It then appears here.":
    "UninfoHK 會設置贊助商並指派到您的帳戶，之後便會顯示在這裡。",
  "Students and societies redeem it and submit proof. Track their progress in the Task Completions tab.":
    "學生和社團會領取並提交證明。您可以在「任務完成」分頁中追蹤進度。",
  "Create New Sponsor": "建立新贊助商",
  "Sponsor Name": "贊助商名稱",
  "Sponsor Description": "贊助商描述",
  "Sponsor Image": "贊助商圖片",
  "Pick an image": "選擇圖片",
  "Sponsor Tasks": "贊助任務",
  "Both the official society Instagram account and each committee account must follow the accounts and like all posts for 1 year. If already done, recruit others to fulfill.":
    "社團官方Instagram帳號及每位幹事帳號必須關注並點讚所有貼文一年。如已完成，請招募他人完成。",
  "Instagram account": "Instagram帳號",
  "Add account": "新增帳號",
  "Number of students": "學生人數",
  "Custom sponsor task (optional)": "自訂贊助任務（可選）",
  "Add custom task": "新增自訂任務",
  "Create Sponsor": "建立贊助商",
  "Delete Sponsor": "刪除贊助",
  "Delete Sponsor Confirm":
    "確定要刪除此贊助商嗎？刪除後學生將不能再兌換此贊助。",
  "Sponsor Deleted": "贊助已刪除",
  "Coupons & Sponsors": "優惠券與贊助",
  empty_coupon_title: "暫無可用優惠券",
  empty_coupon_subtitle: "別擔心！我們有許多精彩優惠券等你探索。",
  empty_sponsor_title: "暫無可用贊助商",
  empty_sponsor_subtitle: "別擔心！我們有許多精彩贊助商等你探索。",
  empty_data_title: "暫無數據",
  "Redeem as:": "兌換身份：",
  Personal: "個人",
  Society: "社團",
  Cancel: "取消",
  Failed: "失敗",
  sponsor_tasks: "贊助任務",
  loading: "載入中...",
  no_sponsor_tasks_found: "未找到贊助任務。",
  days_left: "剩餘天數",
  deadline: "截止日期",
  in_store_use: "店內使用",
  redeemed: "已兌換",
  status_completed: "狀態：已完成",
  status_incomplete: "狀態：未完成",
  "No userId provided.": "未提供用戶ID。",
  "Missing userId for sponsor tasks.": "缺少贊助任務的用戶ID。",
  "Server error: Failed to fetch sponsor tasks.": "伺服器錯誤：獲取贊助任務失敗。",
  "Error: Unknown error.": "錯誤：未知錯誤。",
  "Failed to load sponsor tasks.": "載入贊助任務失敗。",
  task: "任務",
  hku: "香港大學",
  hkust: "香港科技大學",
  cuhk: "香港中文大學",
  polyu: "香港理工大學",
  hkbu: "香港浸會大學",
  cityu: "香港城市大學",
  hksyu: "香港樹仁大學",
  hkmu: "香港都會大學",
  eduhk: "香港教育大學",
  lingu: "嶺南大學",
  hkuspace: "香港大學專業進修學院",
  tw_csmu: "台灣中山醫學大學",
  "Mark all as read": "全部標為已讀",
  Completed: "已完成",
  "Auto-failed by bot": "已被AI自動判定失敗",
  "Auto-failed": "自動失敗",
  Reviewing: "審核中",
  "Awaiting re-submit": "等待重新提交",
  "Awaiting check": "等待檢查",
  "Proof submitted": "已提交證明",
  Pending: "待處理",
  "Verified by bot": "已由AI驗證",
  "Auto-checked by bot": "已由AI自動檢查",
  Error: "錯誤",
  "Failed to approve.": "核准失敗。",
  "Please enter a reason.": "請輸入原因。",
  "Failed to reject.": "拒絕失敗。",
  "HKD ${{amount}}": "港幣 ${{amount}}",
  "Failed to fetch sponsor activities": "無法取得贊助活動",
  "No Compensation": "無需賠償",
  "Receipt Approved": "收據已核准",
  "Receipt Rejected": "收據已拒絕",
  "Receipt Pending": "收據審核中",
  "Compensation: HKD ${{amount}}": "賠償：港幣 ${{amount}}",
  "Compensation Required": "需要賠償",
  "Review in progress by AI...": "AI審核中…",
  "Awaiting review": "等待審核",
  "Input IG Accounts": "輸入IG帳號",
  "Review Task": "審核任務",
  "Username: {{value}}": "用戶名：{{value}}",
  "Input Username": "輸入用戶名",
  "Upload Video": "上傳影片",
  "Upload Image/Video": "上傳圖片或影片",
  "Official Deadline for All Tasks: {{date}}": "所有任務的官方截止日期：{{date}}",
  "You can upload proof or review your task from 1 week before the deadline until the deadline.\nIf you submit at least one proof before the deadline, you will have an extra 7-day cure period after the deadline to upload or review.":
    "你可以在截止日期前一星期至截止日期期間上傳證明或審核你的任務。\n如果你在截止日期前提交至少一份證明，你將享有截止日期後額外7天的寬限期上傳或審核。",
  "Note: If you did not upload any proof before or on the deadline ({{date}}), there is NO cure period after the deadline.":
    "注意：如果你沒有在截止日期（{{date}}）或之前上傳任何證明，截止日期後將沒有寬限期。",
  "You must submit at least one proof before the deadline to be eligible for the 7-day cure period after the deadline.":
    "你必須在截止日期前提交至少一份證明，才有資格享有截止日期後7天的寬限期。",
  "According to the agreement, you have failed the task and are required to pay compensation.":
    "根據協議，你的任務已失敗，需要支付賠償。",
  "Cure Period: {{start}} to {{end}} (7 days after deadline)\n\nYou may upload or review your task only if you submitted proof before the deadline.":
    "寬限期：{{start}} 至 {{end}}（截止日期後7天）\n\n只有在截止日期前提交過證明，你才能上傳或審核任務。",
  "Compensation Receipt": "賠償收據",
  "Your compensation receipt has been approved.": "你的賠償收據已獲核准。",
  "Your compensation receipt was rejected. Please upload a new valid receipt.":
    "你的賠償收據已被拒絕。請上傳新的有效收據。",
  "Reason: {{reason}}": "原因：{{reason}}",
  "Your compensation receipt is under review.": "你的賠償收據正在審核中。",
  "Compensation due: HKD ${{amount}}": "應付賠償：港幣 ${{amount}}",
  "You must upload a compensation receipt.\nThe receipt must clearly show:\n- The name of the recipient\n- The date of payment\n- The name of the person paying the compensation":
    "你必須上傳賠償收據。\n收據必須清楚顯示：\n- 收款人姓名\n- 付款日期\n- 付款人姓名",
  Upload: "上傳",
  "Receipt uploaded successfully!": "收據上傳成功！",
  "Task {{index}}": "任務 {{index}}",
  "Review Failure Reason": "審核失敗原因",
  "You have failed this task due to missing proof after the cure period.":
    "由於寬限期後仍未提交證明，此任務已失敗。",
  "✅ Completed": "✅ 已完成",
  "❌ Failed": "❌ 失敗",
  "⏳ Incomplete": "⏳ 未完成",
  "· Awaiting re-submit": "· 等待重新提交",
  Warning: "警告",
  "Missing sponsor task ID.": "缺少贊助任務ID。",
  Info: "資訊",
  "No changes detected.": "未偵測到任何更改。",
  Success: "成功",
  "Usernames saved successfully!": "用戶名保存成功！",
  "Missing Parameter": "缺少參數",
  "Failed to save usernames: Missing required parameter.": "保存用戶名失敗：缺少必要參數。",
  "Database Error": "資料庫錯誤",
  "Database error: {{error}} (code: {{code}})": "資料庫錯誤：{{error}}（代碼：{{code}}）",
  "Server Error": "伺服器錯誤",
  "Failed to save usernames. Please try again later.": "保存用戶名失敗。請稍後重試。",
  "Failed to save usernames: {{error}} (code: {{code}})":
    "保存用戶名失敗：{{error}}（代碼：{{code}}）",
  "Unknown Error": "未知錯誤",
  "Failed to save usernames: Unknown error": "保存用戶名失敗：未知錯誤",
  "Failed to save registered usernames.": "保存已註冊的用戶名失敗。",
  "Review attempts: {{count}} / 3": "審核次數：{{count}} / 3",
  "You have failed 3 times. There is no extra opportunity for you to complete this task.":
    "你已失敗3次。你不再有機會完成此任務。",
  "Proof submitted successfully!": "證明上傳成功！",
  "Failed to submit proof: Missing required parameter.": "提交證明失敗：缺少必要參數。",
  "Failed to store sponsor task proof. Please try again later.":
    "儲存贊助任務證明失敗。請稍後重試。",
  "Failed to submit proof: {{error}} (code: {{code}})":
    "提交證明失敗：{{error}}（代碼：{{code}}）",
  "Failed to submit proof: Unknown error": "提交證明失敗：未知錯誤",
  "Failed to review ensure_followers task.": "審核「確保追蹤」任務失敗。",
  "No tasks found.": "找不到任務。",
  "Did not upload any proof for this task.": "此任務未上傳任何證明。",
  "Permission Required": "需要權限",
  "Please grant media library access to upload a compensation receipt.":
    "請授予媒體庫存取權限以上傳賠償收據。",
  "Failed to open image picker. Please try again.": "無法開啟圖片選擇器。請重試。",
  "Upload Failed": "上傳失敗",
  "Failed to upload receipt image to CDN. Please try again.":
    "無法將收據圖片上傳至CDN。請重試。",
  "Failed to upload compensation receipt. Please try again.": "無法上傳賠償收據。請重試。",
  "Missing or invalid sponsor activity. Please contact support.":
    "贊助活動缺失或無效。請聯絡支援。",
  "Missing or invalid compensation receipt image.": "賠償收據圖片缺失或無效。",
  "Missing or invalid compensation amount.": "賠償金額缺失或無效。",
  "Sponsor activity not found.": "找不到贊助活動。",
  "Foreign key constraint failed. Please contact support.": "外鍵約束失敗。請聯絡支援。",
  "Failed to upload compensation receipt. Please try again later.":
    "無法上傳賠償收據。請稍後重試。",
  "Compensation receipt uploaded!": "賠償收據已上傳！",
  "Reminder: The second review attempt can only be made on or after the deadline ({{date}}).":
    "提醒：第二次審核嘗試只能在截止日期（{{date}}）當日或之後進行。",
  "Reminder: The third review attempt can only be made on the last day of the cure period ({{date}}).":
    "提醒：第三次審核嘗試只能在寬限期最後一天（{{date}}）進行。",
  "Pending Review": "待審核",
  "Review started. This may take a while. You can check status below.":
    "審核已開始，可能需要一段時間。你可以在下方查看狀態。",
  "{{followers}} did not follow {{target}}": "{{followers}} 並未追蹤 {{target}}",
  "Validation Failed": "驗證失敗",
  "Missing sponsorTaskCompletionId in request body.":
    "請求主體缺少 sponsorTaskCompletionId。",
  "A server error occurred. Please try again later.": "發生伺服器錯誤。請稍後重試。",
  "Invalid Input": "無效輸入",
  "The followers array is missing or invalid in the request.":
    "請求中的追蹤者陣列缺失或無效。",
  "Configuration Error": "配置錯誤",
  "Instagram credentials are missing in the environment. Please contact support.":
    "環境中缺少Instagram憑證。請聯絡支援。",
  "Failed to review task. Please try again later.": "審核任務失敗。請稍後重試。",
  "Failed to review ensure_followers task. {{error}}": "審核「確保追蹤」任務失敗。{{error}}",
  "Usernames saved and review started!": "用戶名已保存，審核已開始！",
  "Missing sponsorTaskCompletionId or registered_usernames. Please check your input.":
    "缺少 sponsorTaskCompletionId 或 registered_usernames。請檢查你的輸入。",
  "Failed to review register_app task: {{error}} (code: {{code}})":
    "審核「註冊應用程式」任務失敗：{{error}}（代碼：{{code}}）",
  "Failed to review register_app task: Unknown error": "審核「註冊應用程式」任務失敗：未知錯誤",
  "Failed to review register_app task.": "審核「註冊應用程式」任務失敗。",
  "Please grant media library access to upload files.": "請授予媒體庫存取權限以上傳檔案。",
  "Failed to open gallery.": "無法開啟媒體庫。",
  "Failed to upload proof.": "上傳證明失敗。",
  "Your submission window has closed. You must submit at least one proof before the deadline to qualify for the cure period.":
    "你的提交期限已過。你必須在截止日期前提交至少一項證明，才能享有寬限期。",
  "Sponsor Tasks Review": "贊助任務審核",
  "Basic Info": "基本資料",
  "Official IG: {{value}}": "官方IG：{{value}}",
  "Committee IGs: {{value}}": "委員會IG：{{value}}",
  "Students can upload proof or review their task from 1 week before the deadline until the deadline.\nIf a student submits at least one proof before the deadline, they will have an extra 7-day cure period after the deadline to upload or review.":
    "學生可以在截止日期前一星期至截止日期期間上傳證明或審核任務。\n如果學生在截止日期前提交至少一份證明，將享有截止日期後額外7天的寬限期上傳或審核。",
  "Students can upload proof or review their task from the activity start until the deadline.\nIf a student submits at least one proof before the deadline, they will have an extra 7-day cure period after the deadline to upload or review.":
    "學生可以在活動開始至截止日期期間上傳證明或審核任務。\n如果學生在截止日期前提交至少一份證明，將享有截止日期後額外7天的寬限期上傳或審核。",
  "Note: If a student did not upload any proof before or on the deadline ({{date}}), there is NO cure period after the deadline.":
    "注意：如果學生沒有在截止日期（{{date}}）或之前上傳任何證明，截止日期後將沒有寬限期。",
  "A student must submit at least one proof before the deadline to be eligible for the 7-day cure period after the deadline.":
    "學生必須在截止日期前提交至少一份證明，才有資格享有截止日期後7天的寬限期。",
  "Cure Period: {{start}} to {{end}} (7 days after deadline)\n\nA student may upload or review their task only if they submitted proof before the deadline.":
    "寬限期：{{start}} 至 {{end}}（截止日期後7天）\n\n只有在截止日期前提交過證明，學生才能上傳或審核任務。",
  "❌ Task failed": "❌ 任務已失敗",
  "❌ Task failed (max review attempts)": "❌ 任務失敗（已達最大審核次數）",
  "❌ Task failed (cure period over)": "❌ 任務失敗（寬限期已結束）",
  "Awaiting business review": "等待商家審核",
  "❌ Task rejected": "❌ 任務已被拒絕",
  "Task Approved": "已核准任務",
  "You have approved this task.": "你已核准此任務。",
  "Failed to approve the task.": "核准任務失敗。",
  "Task Rejected": "已拒絕任務",
  "You have rejected this task.": "你已拒絕此任務。",
  "Failed to reject the task.": "拒絕任務失敗。",
  "This task will be automatically checked by our AI bot. No manual approval is needed.":
    "此任務將由我們的AI機器人自動檢查。無需人手核准。",
  Approve: "核准",
  Reject: "拒絕",
  "Are you sure you want to approve this task?": "你確定要核准此任務嗎？",
  "Review count: {{count}}": "審核次數：{{count}}",
  "Student did not upload proof on time. This task is automatically marked as failed.":
    "學生未能準時上傳證明。此任務已被自動標記為失敗。",
  "Waiting for student to upload new proof during cure period.":
    "等待學生在寬限期內上傳新證明。",
  "Student did not upload proof during the cure period. This task is automatically marked as failed.":
    "學生未在寬限期內上傳證明。此任務已被自動標記為失敗。",
  "Failed to load sponsor completions.": "載入贊助任務完成記錄失敗。",
  "Task Completions": "任務完成記錄",
  "✅ All Sponsor Tasks Completed ({{completed}}/{{total}})":
    "✅ 所有贊助任務已完成（{{completed}}/{{total}}）",
  "Sponsor Tasks: {{completed}}/{{total}} Completed":
    "贊助任務：{{completed}}/{{total}} 已完成",
  "⏰ Deadline: {{date}}": "⏰ 截止日期：{{date}}",
  "Activity: {{name}}": "活動：{{name}}",
  "Redeemed By {{name}}": "由 {{name}} 兌換",
  "No Sponsor Name": "無贊助商名稱",
  Sponsor: "贊助商",
  Redeem: "兌換",
  OK: "確定",
  "Redeeming...": "兌換中…",
  "Reject Task": "拒絕任務",
  "Reject Document": "拒絕文件",
  "Reject Membership Request": "拒絕會籍申請",
  "Please provide a reason for rejection:": "請提供拒絕原因：",
  "Enter reason...": "輸入原因…",
  Submit: "提交",
  "Enter your username(s) for registration:": "請輸入你的用戶名以完成註冊：",
  Save: "保存",
  "Please fill in all {{count}} username(s).": "請填寫全部 {{count}} 個用戶名。",
  "Duplicate usernames found. Please ensure all usernames are unique.":
    "發現重複用戶名。請確保所有用戶名都是唯一的。",
  "Registered account username {{index}}": "已註冊帳戶的用戶名 {{index}}",
  "Please fill in all {{count}} Instagram accounts (each must start with @ and not be empty).":
    "請填寫全部 {{count}} 個Instagram帳號（每個必須以@開頭且不能為空）。",
  "Duplicate Instagram accounts found. Please ensure all accounts are unique.":
    "發現重複的Instagram帳號。請確保所有帳號都是唯一的。",
  "Enter {{count}} Instagram accounts (one per line):":
    "輸入 {{count}} 個Instagram帳號（每行一個）：",
  "Verify Documents": "驗證文件",
  HKID: "香港身份證",
  "No Image": "無圖片",
  "HKID Number": "香港身份證號碼",
  "HKID Name": "香港身份證姓名",
  "Student Card": "學生證",
  "Card Number": "卡號",
  "Card Name": "卡面姓名",
  Close: "關閉",
  "Sign above": "請在上方簽名",
  "Signed": "已簽署",
  "Not signed yet": "尚未簽署",
  Clear: "清除",
  Confirm: "確認",
  "Failed to generate PDF.": "生成PDF失敗。",
  "Failed to upload PDF to Cloudinary.": "上傳PDF至雲端失敗。",
  "Failed to upload PDF to Cloudinary (no URL returned).":
    "上傳PDF至雲端失敗（沒有返回網址）。",
  "[pdf download url missing] no URL returned": "[缺少PDF下載連結] 沒有返回網址",
  Finalize: "完成",
  "Finalizing the agreement...": "正在完成協議…",
  "Sign Now": "立即簽署",
  "No events yet": "暫無活動",
  "Pull to refresh to see the latest events": "下拉刷新以查看最新活動",
  "You're all caught up": "你已看完所有活動",
  "Previous image": "上一張圖片",
  "Next image": "下一張圖片",
  "Latest Events": "最新活動",
  "Load more": "載入更多",
  Subscribe: "訂閱",
  Subscribed: "已訂閱",
  Ended: "已結束",
  "Untitled Event": "未命名活動",
  "All Events": "所有活動",
  "My Events": "我的活動",
  "Events you subscribed to": "你已訂閱的活動",
  "Search events...": "搜尋活動...",
  "Search results for {{keyword}}": "「{{keyword}}」的搜尋結果",
  "No events found": "找不到活動",
  Newest: "最新",
  Soonest: "最近舉行",
  Event: "活動",
  "PostType.Event": "活動",
  "PostType.SocietyActivity": "學會活動",
  "PostType.Result": "賽果",
  "PostType.Recruitment": "招募",
  "PostType.Announcement": "公告",
  "PostType.Post": "貼文",
  "PostType.Other": "其他",
  "Filter by type": "按類型篩選",
  "Filter by university": "按大學篩選",
  "Filter by society": "按社團篩選",
  "Clear filters": "清除篩選",
  "Apply filters": "套用篩選",
  "Clear all": "清除全部",
  "Search events": "搜尋活動",
  "Clear search": "清除搜尋",
  "Search results for": "搜尋結果為",
  "No events match your search": "沒有符合搜尋的活動",
  Organizers: "主辦單位",
  "Who can join?": "誰可以參加？",
  "Everyone can join": "所有人均可參加",
  "No description provided.": "暫無活動介紹。",
  "When & Where": "時間及地點",
  Time: "時間",
  Tags: "標籤",
  "View original post": "查看原始貼文",
  "Open link": "開啟連結",
  WhatsApp: "WhatsApp",
  "Event not found": "找不到活動",
  "This event is no longer available.": "此活動已下架或移除。",
  "{{count}} events": "{{count}} 個活動",
  "Multi-day": "跨日活動",
  "Subscribed only": "只顯示已訂閱",
  "Multi-day only": "只顯示跨日活動",
  "No events on this day": "當日沒有活動",
  "Select a day": "選擇日期",
  "Tap a highlighted day to see its events.": "點擊有標記的日期查看當日活動。",
  "Previous month": "上個月",
  "Next month": "下個月",
  "Add to calendar": "加入行事曆",
  "{{count}} more": "+{{count}} 更多",
  Back: "返回",
  "Please try again later.": "請稍後再試。",
  "Pull to refresh to load events.": "下拉刷新以載入活動。",
  "User List": "用戶列表",
  "Total Students": "學生總數",
  "Pending Verification": "待驗證",
  "Pending Approval": "待審批",
  Businesses: "商戶",
  Students: "學生",
  Verified: "已驗證",
  "Search by name, email, university...": "按姓名、電郵、大學搜尋...",
  "Search by name, email, BR number...": "按姓名、電郵、商業登記號碼搜尋...",
  Filters: "篩選",
  "Verification Status": "驗證狀態",
  "No documents": "沒有文件",
  "Pending review": "待審核",
  "Student card verified": "學生證已核實",
  "HKID verified": "香港身份證已核實",
  "Both documents verified": "兩份文件均已核實",
  "Account Status": "帳戶狀態",
  "Review Status": "審批狀態",
  "Clear All": "全部清除",
  Done: "完成",
  "Check Sponsor": "查看贊助",
  "Select Sponsor": "選擇贊助",
  "Select a sponsor redemption to view.": "選擇一個贊助兌換以查看。",
  "No students found": "找不到學生",
  "No businesses found": "找不到商戶",
  "Awaiting admin approval": "等待管理員審批",
  "Reject this business?": "確定拒絕此商戶？",
  "This action cannot be undone": "此操作無法撤銷",
  Review: "審核",
  "Submitted": "提交於",
  "Your business is awaiting admin approval": "你的商戶正在等待管理員審批",
  "Your business registration was rejected": "你的商戶註冊申請已被拒絕",
  "Your registration has been submitted for admin review. You will be able to log in once it is approved.":
    "你的註冊已提交予管理員審批，審批通過後即可登入。",
  "No users match your search": "沒有符合搜尋條件的用戶",
  "Try adjusting your search or filters": "請嘗試調整搜尋或篩選條件",
  "Something went wrong": "發生錯誤",
  Retry: "重試",
  Refresh: "重新整理",
  "Pull to refresh to load students.": "下拉以重新整理載入學生。",
  "Pull to refresh to load businesses.": "下拉以重新整理載入商戶。",
  Memberships: "會籍",
  Joined: "已加入",
  Requested: "已申請",
  Uploaded: "已上傳",
  "Not uploaded": "未上傳",
  "Approved by member - awaiting admin": "成員已核准 - 等待管理員",
  "Awaiting approval": "待審批",
  "Approve this membership request?": "核准此會籍申請？",
  "Reject this membership request?": "拒絕此會籍申請？",
  "Membership requests": "會籍申請",
  "{{count}} membership requests": "{{count}} 個會籍申請待處理",
  Role: "角色",
  Verify: "驗證",
  "Verify Student Card": "驗證學生證",
  "Verify HKID": "驗證香港身份證",
  Active: "啟用",
  Inactive: "停用",
  "View Details": "查看詳情",
  Agreed: "已同意",
  "No Agreement": "無協議",
  Admin: "管理員",
  "Admin Hub": "管理員中心",
  "Review Sponsor Tasks": "審核贊助任務",
  Members: "成員",
  "Pending Requests": "待處理申請",
  "Quick access to admin tools": "快速存取管理工具",
  Approved: "已核准",
  Rejected: "已拒絕",
  "Why failed": "失敗原因",
  Proof: "證明",
  "View Agreement": "查看協議",
  "Approve Receipt": "核准收據",
  "Reject Receipt": "拒絕收據",
  "Approve this compensation receipt?": "核准此賠償收據？",
  "Reason...": "原因...",
  "Sponsor Activities": "贊助活動",
  Societies: "社團",
  "No societies found.": "找不到社團。",
  "No pending membership requests.": "沒有待處理的會籍申請。",
  "No pending membership requests": "沒有待處理的會籍申請",
  "No sponsor activities found.": "找不到贊助活動。",
  "No societies to review": "沒有需要審核的社團",
  "No sponsor activities to review": "沒有需要審核的贊助活動",
  "Pull to refresh to load societies.": "下拉以重新整理載入社團。",
  "Search societies...": "搜尋社團...",
  "No societies match your search": "沒有符合搜尋結果的社團",
  "{{count}} societies": "{{count}} 個社團",
  "{{count}} society": "{{count}} 個社團",
  "End of results": "已顯示全部結果",
  "Loading more...": "載入中...",
  "Pull to refresh to check for new requests.": "下拉以重新整理查看新申請。",
  "Pull to refresh to load sponsor activities.": "下拉以重新整理載入贊助活動。",
  Filter: "篩選",
  "Pending Memberships": "待處理會籍",
  Business: "商戶",
  Gender: "性別",
  University: "大學",
  Identity: "身份",
  Tasks: "任務",
  "Please fill in all the blank": "請填寫所有欄位",
  "Network error, please try again": "網絡錯誤，請重試",
  "Password must be at least 8 digits!": "密碼必須至少8位！",
  "Password and Confirmed Password are not match": "密碼與確認密碼不一致",
  "Enter the verification code": "輸入驗證碼",
  "Verification Code": "驗證碼",
  "RESEND VERIFICATION CODE": "重新發送驗證碼",
  "Phone Verification": "電話驗證",
  "Enter the SMS code sent to your phone": "輸入發送到你手機的驗證碼",
  "SMS code": "簡訊驗證碼",
  "SEND CODE": "發送驗證碼",
  "Resend code": "重新發送驗證碼",
  "Code verified": "驗證碼已確認",
  "Verify new phone number": "驗證新的電話號碼",
  "Phone number changed successfully": "電話號碼已成功更改",
  "Phone verification required": "請先驗證你的新電話號碼。",
  "Phone number is not verified": "電話號碼尚未驗證",
  "Saving...": "儲存中...",
  "Sending...": "發送中...",
  "Verifying...": "驗證中...",
  VERIFY: "驗證",
  "Phone Existed": "電話號碼已存在",
  "Please verify your phone number": "請驗證你的電話號碼",
  "Please enter the SMS code": "請輸入簡訊驗證碼",
  "Invalid verification code": "驗證碼無效",
  "Verification code expired, please resend": "驗證碼已過期，請重新發送",
  "Too many attempts, please resend": "嘗試次數過多，請重新發送",
  "Verification code already used, please resend": "驗證碼已被使用，請重新發送",
  "SMS service not configured": "簡訊服務未設定",
  ENTER: "輸入",
  "Custom your Profile icon": "自訂你的個人資料圖示",
  NEXT: "下一步",
  SKIP: "跳過",
  "Please select your profile icon": "請選擇你的個人資料圖示",
  "Scan your university card": "掃描你的學生證",
  "Upload your university card": "上傳你的學生證",
  "Please select your student card": "請選擇你的學生證",
  BACK: "返回",
  "QR SCAN": "二維碼掃描",
  "OPEN SCANNER": "開啟掃描器",
  "Invalid QR code": "無效的二維碼",
  "Please login": "請登入",
  "Select your univesity": "選擇你的大學",
  "Select your Gender": "選擇你的性別",
  "Select your Identity": "選擇你的身份",
  Undergraduate: "本科生",
  Postgraduate: "研究生",
  "Teaching Staff": "教學人員",
  "Administrative or Research Staff": "行政或研究人員",
  Alumni: "校友",
  Retiree: "退休人士",
  "Year one": "一年級",
  "Year Two": "二年級",
  "Year Three": "三年級",
  "Year Four": "四年級",
  "Year Five": "五年級",
  "Year Six": "六年級",
  "Year Seven": "七年級",
  "Year Eight or above": "八年級或以上",
  "Year Of Study*": "就讀年級*",
  "Please select year of study": "請選擇就讀年級",
  "Select Year Of Study": "選擇就讀年級",
  "Can`t register account": "無法註冊帳戶",
  Setting: "設定",
  Logout: "登出",
  "EXPLORE NOW": "立即探索",
  "REGISTERED SUCCESSFULLY": "註冊成功",
  "Logout Now?": "現在登出？",
  LOGOUT: "登出",
  LOGIN: "登入",
  "LOG IN": "登入",
  Following: "追蹤中",
  Subscription: "訂閱",
  "EDIT PROFILE": "編輯個人資料",
  "SHARE PROFILE": "分享個人資料",
  "Your Societies / Clubs*": "你的社團／學會*",
  "Select your Societies / Clubs": "選擇你的社團／學會",
  "Societies / Clubs": "社團／學會",
  "Upload Event Image (max 10)": "上傳活動圖片（最多10張）",
  "Title*": "標題*",
  "Description (optional)": "描述（可選）",
  Location: "地點",
  "Location (optional)": "地點（可選）",
  "Max. 20 HashTags": "最多20個標籤",
  "Please Input Email": "請輸入電郵",
  "Invalid Email": "無效的電郵",
  "Invalid Phone Number": "無效的電話號碼",
  "Please Input Link": "請輸入連結",
  "Please Input Event Title": "請輸入活動標題",
  "Please Select Event Society": "請選擇活動社團",
  "Date & Time*": "日期及時間*",
  "Choose...": "選擇...",
  "Application Deadline": "申請截止日期",
  "Allow User to apply the activity through Uninfo": "允許用戶透過Uninfo申請參加活動",
  "Event Targets": "活動對象",
  "UPLOAD EVENT": "上傳活動",
  "Bachelor degree": "學士學位",
  "Year of study": "就讀年級",
  "Never Repeat": "不重複",
  "Daily Repeat": "每日重複",
  "Weekly Repeat": "每週重複",
  "End Time On": "結束時間",
  "Repeat Daily or Weekly?": "每日或每週重複？",
  "Daily Repeat until": "每日重複至",
  "Weekly Repeat until": "每週重複至",
  "JOIN EVENT NOW": "立即參加活動",
  "APPLICATION DATE - ": "申請日期 - ",
  "JOIN THIS EVENT": "參加此活動",
  "YOU WILL BE NOTIFIED": "你將收到通知",
  "WHEN YOUR ELIGIBILITY IS CONFIRMED": "當你的資格獲確認時",
  "You are not eligible": "你不符合資格",
  "UNJOIN EVENT": "取消參加活動",
  "UNJOIN THIS EVENT": "取消參加此活動",
  "UNJOIN THIS EVENT ?": "取消參加此活動？",
  "APPLICATION REJECTRED": "申請被拒絕",
  "APPLICATION ACCEPTED": "申請已接受",
  Calendar: "行事曆",
  FOLLOW: "追蹤",
  FOLLOWING: "追蹤中",
  ALL: "全部",
  "WELCOME TO JOIN": "歡迎加入",
  FINISHED: "已結束",
  JOINED: "已加入",
  "IN PROCESS": "處理中",
  "CREATE YOUR SURVEY": "建立你的問卷",
  Rewards: "獎勵",
  "Enhance the allure of this survey by penning down your desired reward":
    "填寫你想要的獎勵以提升問卷吸引力",
  "Please Fill In The Title": "請填寫標題",
  "UPLOAD SURVEY": "上傳問卷",
  "Question Type": "問題類型",
  "Select your question type": "選擇你的問題類型",
  "Your Question": "你的問題",
  number: "數字",
  Number: "數字",
  now: "現在",
  Question: "問題",
  PREVIOUS: "上一步",
  REWARDS: "獎勵",
  "GIVING REWARDS": "發放獎勵",
  "GIVING REWARDS?": "發放獎勵？",
  "CONTACT PARTICIPANT": "聯絡參加者",
  Published: "已發布",
  "Expire in": "將於以下時間到期",
  EXPIRED: "已過期",
  PARTICIPANTS: "參加者",
  "EDIT EVENT": "編輯活動",
  "Edit Profile": "編輯個人資料",
  "APPLICATION PROCESSING": "申請處理中",
  "BOOKING FULL": "名額已滿",
  "Login To Explore More": "登入以探索更多",
  "Manage Society": "管理社團",
  "English Name": "英文名稱",
  "Chinese Name": "中文名稱",
  "Delete Event?": "刪除活動？",
  Delete: "刪除",
  "Target Year Of Study": "目標就讀年級",
  "Coupon Icon": "優惠券圖示",
  "Redeem Coupons": "兌換優惠券",
  "Quatity*": "數量*",
  Quatity: "數量",
  "ADD NOW": "立即新增",
  "Redeem Coupon?": "兌換優惠券？",
  "No terms":
    "任何條款及最終解釋權歸UninfoHK所有。如有任何爭議，UninfoHK保留最終決定權。本優惠受香港特別行政區適用法律及法規約束。",
  "Not Enough Point": "積分不足",
  "Use It Now?": "立即使用？",
  "Use It Now": "立即使用",
  "Joined Society": "已加入的社團",
  "Brief the tasks that you need the university student to complete":
    "簡述你需要大學生完成的任務",
  FREE: "免費",
  "Add Member": "新增成員",
  "New Member University Email": "新成員的大學電郵",
  "Remove Member?": "移除成員？",
  Remove: "移除",
  "Get Your Coupon Code In Chat Room": "在聊天室獲取你的優惠券代碼",
  "Change Password": "更改密碼",
  "Old Password": "舊密碼",
  "New Password": "新密碼",
  "The old password is not correct": "舊密碼不正確",
  Enquiry: "查詢",
  "Complete Survey To Earn 10 Points": "完成問卷賺取10積分",
  "Join Activity To Earn 20 Points": "參加活動賺取20積分",
  "Redeem The Coupon Successfully": "成功兌換優惠券",
  "Scan To Use The Coupon Successfully": "成功掃描使用優惠券",
  "Need To Complete Tasks": "需要完成任務",
  "Contact Business": "聯絡商戶",
  "Contact Business?": "聯絡商戶？",
  "Get Promo Code": "獲取推廣碼",
  "Please upload your student card": "請上傳你的學生證",
  "Registration Code (optional)": "註冊代碼（可選）",
  "Registration Code Is Not Valid": "註冊代碼無效",
  "Sponsor Activity": "贊助活動",
  "Society Instagram Name": "社團Instagram名稱",
  "Society Instagram Followers": "社團Instagram追蹤人數",
  "Activity Name": "活動名稱",
  "Quantity Of Participants": "參加人數",
  "You are not eligible to redeem sponsor": "你不符合兌換贊助的資格",
  "Request To Redeem Sponsor Successfully. Please Wait For Sponsor Provider To Accept Your Request":
    "贊助兌換申請已成功提交。請等待贊助商接受你的申請",
  SPONSORS: "贊助商",
  "Activity Title": "活動標題",
  Participants: "參加者",
  "Please Input Task": "請輸入任務",
  "ADD TASKS": "新增任務",
  "ASSIGN TO SOCIETY NOW": "立即指派給社團",
  "Assign To Society?": "指派給社團？",
  "Once you assign to society. You can`t edit or add the tasks":
    "一旦指派給社團，你將無法編輯或新增任務",
  UPLOAD: "上傳",
  "ADD PHOTOS": "新增照片",
  "PLEASE WAIT FOR TASKS": "請等待任務",
  "Please Add Tasks": "請新增任務",
  "Wait For Society To Accept Your Tasks": "等待社團接受你的任務",
  "Waiting For Check": "等待檢查",
  "Check Tasks Now": "立即檢查任務",
  "Society Has Not Yet Uploaded Task Prove": "社團尚未上傳任務證明",
  "Images as verification of the completed task": "作為任務完成證明的圖片",
  "Activity Start Date": "活動開始日期",
  "Valid Duration": "有效期限",
  "Start time": "開始時間",
  "End time": "結束時間",
  "Coupon Category": "優惠券類別",
  "Discount Coupon": "折扣優惠券",
  "Buy 1 Get 1 Free": "買一送一",
  "Free Item": "免費贈品",
  "Free Shipping": "免運費",
  Cashback: "現金回贈",
  "This coupon type is coming soon": "此優惠券類型即將推出",
  "Set buy quantity and free quantity": "設定購買數量及贈送數量",
  "Buy Quantity": "購買數量",
  "Free Quantity": "贈送數量",
  "Coupon Type": "優惠券類型",
  "Coupons can only discount the price of items": "優惠券只能用於折扣商品價格",
  "% Off": "折扣百分比",
  "Amount Off": "折扣金額",
  "Discount amount": "折扣金額",
  "Redeem Times per user": "每位用戶可兌換次數",
  "Ensure X students (not committee, not already followers) follow all accounts for 1 year.":
    "確保X名學生（非幹事、非現有追蹤者）追蹤所有帳號一年。",
  "Committee must download and register for the Uninfo HK app. If already registered, recruit another student who has not registered to do so.":
    "幹事必須下載並註冊Uninfo HK應用程式。如已註冊，請招募另一名未註冊的學生完成。",
  "Publish one Story and Post, tagging @uninfohk and @we2tech, expressing gratitude to the Sponsor Provider and promoting the Uninfo HK platform. The official account Post is subject to prior written approval by the Sponsor Provider and must remain published and visible for at least one (1) year to ensure continuous compliance with this obligation.":
    "發布一則限時動態及貼文，標註@uninfohk和@we2tech，向贊助商表達感謝並推廣Uninfo HK平台。官方帳號的貼文須事先獲得贊助商書面批准，並須保持發布及可見至少一（1）年，以確保持續遵守此義務。",
  Chats: "對話",
  "Manage Chat": "管理對話",
  "Leave this chat?": "離開此對話？",
  Leave: "離開",
  "Search chats...": "搜尋對話...",
  "No chats match your search": "沒有符合搜尋結果的對話",
  "No chats yet": "暫時沒有對話",
  "Try a different name.": "請嘗試其他名稱。",
  "Start a chat from your redeemed coupons, sponsors or Settings.":
    "請從已兌換的優惠券、贊助商或設定中開始對話。",
  "Type a message...": "輸入訊息...",
  "No messages yet": "暫時沒有訊息",
  "Send a message to start the conversation.": "發送訊息開始對話。",
  Today: "今天",
  Yesterday: "昨天",
  "You:": "你：",
  Send: "發送",
  "Reconnecting...": "重新連線中...",
  "Chat with Admin": "聯絡管理員",
  Online: "在線",
  Offline: "離線",
  "Last seen just now": "最後在線：剛剛",
  "Last seen today at {{time}}": "最後在線：今日 {{time}}",
  "Last seen yesterday at {{time}}": "最後在線：昨日 {{time}}",
  "Last seen {{date}} at {{time}}": "最後在線：{{date}} {{time}}",
  Read: "已讀",
  Group: "群組",
  Dashboard: "儀表板",
  "User Management": "用戶管理",
  "Admin Console": "管理員控制台",
  Welcome: "歡迎",
  "Page not found": "找不到頁面",
  "Go to Login": "前往登入",
  "The student and business web portal is coming soon.": "學生及商戶網頁入口即將推出。",
  "Recent Societies": "最新社團",
  "Activity not found.": "找不到活動。",
  "Failed to load activity details.": "載入活動詳情失敗。",
  "No userId or activityId provided.": "未提供用戶ID或活動ID。",
  "Log In": "登入",
  "Join as Student": "加入成為學生",
  "Join as Business": "加入成為商戶",
  "Business Sign In": "商戶登入",
  "Sign in to your account": "登入你的帳戶",
  "New to Uninfo HK?": "新嚟Uninfo HK？",
  Home: "首頁",
  Features: "功能",
  Universities: "大學",
  About: "關於我們",
  Contact: "聯絡我們",
  Explore: "探索",
  "All rights reserved.": "版權所有。",
  "The all-in-one campus life platform for Hong Kong university students.":
    "專為香港大學生而設的一站式校園生活平台。",
  "Hong Kong's campus life platform": "香港校園生活平台",
  "Your university life,": "你的大學生活，",
  "all in one place.": "盡在一處。",
  "Discover events, join societies, complete surveys and redeem coupons — built for Hong Kong university students.":
    "發掘活動、加入社團、完成問卷、兌換優惠券——專為香港大學生而設。",
  "Discover events, join societies, chat with organizers and redeem coupons — built for Hong Kong university students.":
    "發掘活動、加入屬會、與幹事聊天並兌換優惠券 — 專為香港大學生而設。",
  "For students": "學生免費",
  "For Students": "學生專享",
  "Upcoming Events": "即將舉行的活動",
  "This week": "本週",
  "Everything your campus life needs": "校園生活所需的一切",
  "Events & Calendar": "活動與行事曆",
  "Discover campus events, save them to your calendar and never miss out.":
    "發掘校園活動，儲存到你的行事曆，絕不錯過。",
  Surveys: "問卷",
  "Chat with societies": "與屬會聊天",
  "Message organizers and societies in real time and stay in the loop.":
    "即時聯繫屬會幹事，隨時掌握最新消息。",
  "Activities & QR Check-in": "活動與QR簽到",
  "Society Activities": "屬會活動",
  "Join activities hosted by campus societies across Hong Kong.":
    "參加全港各大學屬會舉辦的活動。",
  "Business Activities": "商戶活動",
  "Join workshops and activities hosted by partner businesses.":
    "參加合作商戶舉辦的工作坊及活動。",
  "Check in instantly with a real-time QR code at every activity.":
    "於每個活動即時以QR碼簽到。",
  "Coupons & Redeem": "優惠券與兌換",
  "Earn points and redeem them for coupons at partner shops.":
    "賺取積分，並於合作商戶兌換優惠券。",
  "Earn points from surveys and activities, then redeem them for coupons from partner businesses across Hong Kong.":
    "透過問卷及活動賺取積分，再兌換全港合作商戶的優惠券。",
  "Follow societies and get campus updates": "追蹤屬會，緊貼校園消息",
  "Join activities to earn 20 points": "參加活動賺取20積分",
  "Redeem coupons from partner shops": "兌換合作商戶的優惠券",
  Points: "積分",
  Partners: "合作夥伴",
  "Societies we sponsor and partner with": "我們贊助並合作的社團",
  "Uninfo HK partners with campus societies to bring their events, updates and everything happening on your campus to you.":
    "Uninfo HK 與校園社團合作，為你帶來他們的活動、最新消息及校園內的一切動態。",
  members: "位成員",
  "…and many more societies are partnering with us": "…另有更多社團與我們合作",
  "How It Works": "運作方式",
  "Get started in four simple steps": "四個簡單步驟即可開始",
  "Create account": "建立帳戶",
  "Sign up with your verified university email in under a minute.":
    "使用已驗證的大學電郵，一分鐘內完成註冊。",
  "Browse events": "瀏覽活動",
  "Explore events, coupons and societies across Hong Kong.": "探索全港活動、優惠券及屬會。",
  "Join & subscribe": "加入及訂閱",
  "Follow societies and subscribe to the events you care about.":
    "追蹤社團並訂閱你關心的活動。",
  "Check-in & explore": "簽到與探索",
  "Check in with your QR code and explore everything your campus offers.":
    "以QR碼簽到，探索校園的一切精彩。",
  "Why Choose Us": "為何選擇我們",
  "Built for Hong Kong students": "專為香港學生打造",
  "Verified university email": "已驗證的大學電郵",
  "Easy join": "輕鬆加入",
  "Free access": "免費使用",
  "Realtime QR check-in": "即時QR簽到",
  "Multi-university": "跨大學支援",
  Flexible: "靈活彈性",
  "Serving all major Hong Kong universities": "服務全港主要大學",
  "Are you a business or society?": "你是商戶或社團嗎？",
  "Reach students and societies across the university community in Hong Kong.":
    "觸及香港大學社群的學生與學會。",
  "Reach thousands of verified university students across Hong Kong.":
    "接觸全港數以千計已驗證的大學生。",
  Testimonials: "學生心聲",
  "Loved by students": "深受學生喜愛",
  "Business portal coming soon": "商戶平台即將推出",
  "We are onboarding partner businesses now. Please contact us to get early access.":
    "我們正在招募合作商戶。請聯絡我們以優先體驗。",
  "Contact Us": "聯絡我們",
  Follow: "追蹤",
  "Partner Businesses & Coupons": "合作商戶與優惠券",
  "Partner businesses": "合作商戶",
  "Partner businesses across Hong Kong back their offers through Uninfo coupons — and sponsors fund even more.":
    "全港合作商戶透過Uninfo優惠券支持你的校園生活——贊助商更提供額外資助。",
  "Redeem points for coupons you will love": "用積分兌換你喜愛的優惠券",
  "Earn points and redeem them at partner shops across Hong Kong — dining, entertainment, shopping, beauty, fashion and fitness.":
    "賺取積分，並在全港合作商戶兌換優惠券 — 涵蓋飲食、玩樂、購物、美容、時裝及健身。",
  Eat: "飲食",
  Play: "玩樂",
  Buy: "購物",
  Beauty: "美容",
  Fashion: "時裝",
  Fitness: "健身",
  "Coupon types": "優惠類型",
  Travel: "旅遊",
  Wellness: "健康養生",
  Education: "學習進修",
  Pets: "寵物",
  Coffee: "咖啡",
  Gifts: "禮品",
  "Redeem coupons": "兌換優惠券",
  "Available in the Uninfo app": "App 內可用",
  "Get the App": "下載 App",
  "Download on the App Store": "於 App Store 下載",
  "Get it on Google Play": "於 Google Play 取得",
  "Sponsor Programme": "贊助計劃",
  "Sponsored by Uninfo HK": "由Uninfo HK贊助",
  "Uninfo HK funds and hosts sponsorships for societies and events across Hong Kong.":
    "Uninfo HK為全港社團及活動提供贊助及支援。",
  "University Sponsor Fund": "大學贊助基金",
  "For Business": "商戶專區",
  "Universities we partner with": "我們合作的大學",
  "Trusted by societies across HK": "獲全港社團信賴",
  "Join our partner network to put your brand in front of thousands of verified students.":
    "加入我們的合作網絡，讓你的品牌接觸數以千計已驗證的學生。",
  "About Uninfo HK": "關於Uninfo HK",
  "Uninfo HK is a campus life platform connecting Hong Kong university students with events, societies, surveys and partner businesses — all in one place.":
    "Uninfo HK是一個校園生活平台，將香港大學生與活動、社團、問卷及合作商戶連繫起來——盡在一處。",
  "Our mission": "我們的使命",
  "University life is full of opportunities — but they are scattered across apps, posters and word of mouth. Our mission is to bring every event, society and offer onto one simple platform, so students can spend less time searching and more time doing.":
    "大學生活充滿機會——但它們分散於不同應用程式、海報及口耳相傳之中。我們的使命是將每個活動、社團及優惠匯聚於一個簡單平台，讓學生花更少時間搜尋，更多時間投入。",
  "Today we serve students across all major Hong Kong universities, and we are just getting started.":
    "今天我們已服務全港主要大學的學生，而這只是開始。",
  "What we value": "我們的價值",
  "Community first": "社群為先",
  "We bring societies, students and businesses together on one trusted platform.":
    "我們將社團、學生及商戶匯聚於一個值得信賴的平台。",
  "Verified & safe": "驗證與安全",
  "Every student account is tied to a verified university email.":
    "每個學生帳戶均與已驗證的大學電郵綁定。",
  "Made for students": "為學生而設",
  "Free to use, built around the way Hong Kong students actually live.":
    "免費使用，圍繞香港學生的真實生活而建。",
  "Ready to explore?": "準備好探索了嗎？",
  "Everything you need to make the most of your university life.":
    "善用大學生活所需的一切。",
  "Browse events from every society, save them to your calendar and get reminded before they start.":
    "瀏覽各社團的活動，儲存到行事曆並在開始前收到提醒。",
  "Search and filter events by university, society and date":
    "按大學、社團及日期搜尋和篩選活動",
  "Save events to your personal calendar": "將活動儲存到個人行事曆",
  "Apply to join events with one tap": "一鍵申請參加活動",
  "Complete surveys from societies and universities to earn points and shape campus life.":
    "完成社團及大學問卷以賺取積分，塑造校園生活。",
  "Answer surveys and earn 10 points each": "回答問卷，每份賺取10積分",
  "See survey results and statistics": "查看問卷結果及統計",
  "Create your own surveys as a society": "以社團身份建立自己的問卷",
  "Join activities and check in instantly with a real-time QR code — no queues, no paper.":
    "參加活動並以即時QR碼快速簽到——毋須排隊，毋須紙張。",
  "Real-time QR check-in at events": "活動即時QR簽到",
  "Instant attendance confirmation": "即時出席確認",
  "Earn 20 points per activity joined": "每參加一個活動賺取20積分",
  "Turn your points into real value with coupons from partner businesses across Hong Kong.":
    "以積分兌換全港合作商戶的優惠券，將積分變成實際價值。",
  "Redeem coupons with your earned points": "以賺取的積分兌換優惠券",
  "Discover offers from partner shops": "發掘合作商戶的優惠",
  "Use coupons with a simple scan": "簡單掃描即可使用優惠券",
  "Follow societies, join their memberships and never miss what they are up to.":
    "追蹤社團、加入會籍，絕不錯過他們的最新動態。",
  "Follow and subscribe to societies": "追蹤及訂閱社團",
  "Join society memberships": "加入社團會籍",
  "Get updates on society events": "獲取社團活動的最新消息",
  "Ready to get started?": "準備好開始了嗎？",
  "Uninfo HK serves students across all major Hong Kong universities.":
    "Uninfo HK服務全港主要大學的學生。",
  "Your university not listed?": "你的大學不在名單上？",
  "We are expanding all the time. Contact us to bring Uninfo to your campus.":
    "我們一直在擴展。聯絡我們，將Uninfo帶到你的校園。",
  "Questions, feedback or partnership ideas? We would love to hear from you.":
    "有問題、意見或合作構思？我們很樂意聆聽。",
  "Get in touch": "聯絡我們",
  Social: "社交媒體",
  "Send us a message": "向我們發送訊息",
  Name: "姓名",
  "Your name": "你的姓名",
  Message: "訊息",
  "How can we help?": "我們可以如何協助你？",
  "Send Message": "發送訊息",
  "Message sent": "訊息已發送",
  "Thank you for reaching out. We will get back to you soon.":
    "感謝你的聯絡。我們會盡快回覆。",
  "Create your account with your university email.": "使用你的大學電郵建立帳戶。",
  "Create your account with your company email.": "使用你的公司電郵建立帳戶。",
  Profile: "個人資料",
  "Change photo": "更換照片",
  "Could not cache this photo. It will still be uploaded when you register.":
    "無法暫存此相片，但註冊時仍會上傳。",
  Male: "男",
  Female: "女",
  Others: "其他",
  "Welcome to Uninfo HK. Your account is ready!": "歡迎加入Uninfo HK。你的帳戶已準備就緒！",
  "Your campus life, all in one place.": "你的校園生活，盡在一處。",
  Events: "活動",
  "Browse campus events": "瀏覽校園活動",
  "QR Check-in": "QR簽到",
  "Check in at activities": "在活動中簽到",
  Coupons: "優惠券",
  "Redeem your points": "兌換你的積分",
  "Follow your societies": "追蹤你的社團",
  "The full student experience is coming soon.": "完整的學生體驗即將推出。",
  "Events, coupons and more are on the way.": "活動、優惠券及更多功能即將登場。",
  "My Societies": "我的社團",
  "No societies yet": "尚未加入任何社團",
  "Societies you join will appear here.": "你加入的社團會顯示在這裡。",
  "Societies you follow will appear here.": "你追蹤的社團會顯示在這裡。",
  Unfollow: "取消關注",
  Unsubscribe: "取消訂閱",
  "Events you subscribe to will appear here.": "你訂閱的活動會顯示在這裡。",
  "No notifications yet": "暫無通知",
  "Notifications from societies and Uninfo HK will appear here.":
    "來自社團及Uninfo HK的通知會顯示在這裡。",
  "Profile updated successfully!": "個人資料已成功更新！",
  "Password changed successfully!": "密碼已成功更改！",
  "You'll be signed out of your account.": "你將會登出帳戶。",
  Notifications: "通知",
  Messages: "訊息",
  "Coming soon": "即將推出",
  "Business Portal": "商戶平台",
  "Back to Home": "返回首頁",
  "Welcome back": "歡迎回來",
  "Sign in to access your account": "登入以存取你的帳戶",
  Student: "學生",
  Terms: "條款",
  Privacy: "私隱",
  "← Back to home": "← 返回首頁",
  "Terms of Service": "服務條款",
  "Privacy Policy": "私隱政策",
  "Please read these terms carefully before using the Uninfo HK platform.":
    "使用Uninfo HK平台前，請仔細閱讀以下條款。",
  "By creating an account or using our services, you agree to these terms.":
    "建立帳戶或使用我們的服務，即表示你同意這些條款。",
  "We collect the information you provide when creating an account, such as your university email and profile details.":
    "我們會收集你在建立帳戶時提供的資料，例如你的大學電郵及個人資料。",
  "We use your data to provide, maintain and improve our services.":
    "我們使用你的資料以提供、維護及改善我們的服務。",
  "Scan QR to redeem": "掃描二維碼兌換",
  "Only students can redeem coupons": "優惠券僅限學生兌換",
  "Refresh to see the latest offers": "重新整理以查看最新優惠",
  "Refresh to see the latest sponsors": "重新整理以查看最新贊助商",
  "Show QR code": "顯示二維碼",
  "Show this QR code to the shop staff": "向店員出示此二維碼",
  "Terms & Conditions": "條款及細則",
  "Tap to view terms": "點擊查看條款",
  "Points to redeem": "所需積分",
  HKD: "港幣",
  "Valid until": "有效至",
  "Promo Code": "推廣碼",
  "Redeemed Coupon Expired": "已兌換的優惠券已過期",
  "Scan again": "重新掃描",
  "Starting camera...": "正在開啟鏡頭…",
  "Camera permission denied. Please enable it in your browser settings.":
    "鏡頭權限被拒絕，請在瀏覽器設定中允許使用鏡頭。",
  "No camera found on this device.": "此裝置找不到鏡頭。",
  "The camera is being used by another application.": "鏡頭正被其他應用程式使用。",
  "Camera access requires a secure (HTTPS) connection.": "使用鏡頭需要安全的 HTTPS 連線。",
  "Unable to start the camera. Please try again.": "無法開啟鏡頭，請再試一次。",
  "Create Event": "建立活動",
  "Create Event Successfully!": "活動建立成功！",
  "Edit Event Successfully!": "活動編輯成功！",
  "My Created Events": "我建立的活動",
  "Events uploaded by your societies": "你的社團／學會上載的活動",
  "Events you upload will appear here.": "你上載的活動會在這裡顯示。",
  "Join a society to create an event": "加入社團／學會即可建立活動",
  "Step {{current}} of {{total}}": "第 {{current}} 步，共 {{total}} 步",
  Next: "下一步",
  "The first image is used as the cover of your event.": "第一張圖片將作為活動封面。",
  Cover: "封面",
  "Add Image": "新增圖片",
  "Hash tags cannot be changed after the event is created.": "活動建立後無法更改標籤。",
  "Add a tag": "新增標籤",
  "End date cannot be earlier than the start date": "結束日期不可早於開始日期",
  "All Day": "全日",
  "Allow all users to join this event": "允許所有用戶參加此活動",
  "Select your Bachelor degree": "選擇你的學士學位",
  "Search bachelor degrees...": "搜尋學士學位...",
  Selected: "已選擇",
  "No result found": "找不到結果",
  "Create Coupon": "建立優惠券",
  "Can`t Create Coupon": "無法建立優惠券",
  "Enable QR Redemption": "啟用 QR 碼兌換",
  "Show QR": "顯示 QR 碼",
  Scan: "掃描",
  "Delete Coupon": "刪除優惠券",
  "Delete Coupon Confirm":
    "商品一旦刪除，將不再向學生展示。已兌換的學生在到期前仍可使用。",
  "Coupon Deleted": "優惠券已刪除",
  "Customer scans to redeem": "顧客掃描此 QR 碼即可兌換",
  Sponsors: "贊助商",
  Change: "更改",
  "Previous Month": "上一個月",
  "Next Month": "下一個月",
  "No sponsor tasks found.": "未找到贊助任務。",
  Used: "已使用",
  "Reach & Engagement": "觸達與參與",
  "Coupon Reads": "優惠券閱讀次數",
  "Coupon Redeemed": "優惠券兌換次數",
  "Sponsor Reads": "贊助閱讀次數",
  "Sponsor Redeemed": "贊助兌換次數",
  Reads: "閱讀次數",
  Readers: "閱讀人數",
  View: "查看",
  "Company Name": "公司名稱",
  "Company Email": "公司電郵",
  "Contact Number": "聯絡電話",
  "Company Address": "公司地址",
  "BR Number": "商業登記號碼",
  "BR Document": "商業登記文件",
  "Member Since": "加入日期",
  "Billing & Plan": "帳單與方案",
  "Current Plan": "目前方案",
  Monthly: "月繳",
  Yearly: "年繳",
  month: "月",
  year: "年",
  "No active plan": "尚未選擇方案",
  "Free until {{date}}": "免費至 {{date}}",
  "Renews on {{date}}": "將於 {{date}} 續期",
  "Choose Plan": "選擇方案",
  "Manage Billing": "管理帳單",
  "Outstanding balance": "未繳結餘",
  "Nothing outstanding": "沒有未繳款項",
  "Card on file": "已儲存的信用卡",
  "Late fee": "逾期費用",
  Shortfall: "不足費用",
  Expiry: "到期",
  "Expiry month": "到期月份",
  "Expiry year": "到期年份",
  "Card number": "信用卡號碼",
  "Security code (CVC)": "保安碼 (CVC)",
  "Cardholder name (optional)": "持卡人姓名（選填）",
  "See the Dashboard for the month-by-month statement.":
    "逐月結算明細請前往控制台查看。",
  "Cancel Subscription": "取消訂閱",
  "Re-enable auto-renewal": "恢復自動續期",
  "Change Plan at Next Renewal": "於下次續期更改方案",
  "Subscription ends on {{date}}": "訂閱將於 {{date}} 結束",
  "from next renewal": "於下次續期起生效",
  "First 100 businesses: first year free": "首 100 間商戶：首年免費",
  "Your plan stays active until {{date}}. Continue?":
    "方案將生效至 {{date}}，是否繼續？",
  "the end of the current period": "本個計費週期結束時",
  "Minimum term ends {{date}}": "最低合約期於 {{date}} 結束",
  "Auto-renewal cancelled — plan ends on {{date}}":
    "已取消自動續期 — 方案將於 {{date}} 結束",
  "Cancelling will stop your plan at the end of your 12-month minimum term ({{date}}). Continue?":
    "取消後，您的方案將於 12 個月最低合約期屆滿時（{{date}}）停止。是否繼續？",
  "A 12-month minimum term applies to the Yearly plan.":
    "年繳方案設有 12 個月最低合約期。",
  "Payment overdue": "付款逾期",
  "Please pay by {{date}} to avoid a late fee of HKD {{amount}} per day.":
    "請於 {{date}} 前付款，否則將每日收取 HKD {{amount}} 的逾期費用。",
  "Late fee accrued: HKD {{amount}}": "已累積逾期費用：HKD {{amount}}",
  "Pay now": "立即付款",
  "Your subscription has ended. Please renew to continue.":
    "您的訂閱已結束，請續訂以繼續使用。",
  "Your subscription has ended. Paid features are disabled until the account is reactivated.":
    "您的訂閱已結束。帳戶重新啟用前，付費功能將停用。",
  "Contact support to reactivate your account.":
    "聯絡客服以重新啟用您的帳戶。",
  "A late fee of HKD {{amount}} has accrued over {{days}} day(s).":
    "已累積逾期費用 HKD {{amount}}（共 {{days}} 天）。",
  "Update your card or pay the outstanding amount to avoid losing access.":
    "更新信用卡或繳清欠款，以免喪失使用權限。",
  "Your card on file is no longer valid.": "您儲存的信用卡已失效。",
  "Use the Update card button below to update your payment method.":
    "請使用下方的「更新信用卡」按鈕來更新付款方式。",
  "Your last payment failed.": "您上一期的付款失敗。",
  "Update your card to complete the payment.":
    "更新信用卡以完成付款。",
  "Auto-renewal is off. Your plan stays active until {{date}}.":
    "自動續期已關閉。您的方案將持續生效至 {{date}}。",
  "First 100: your first year is free until {{date}}.":
    "首 100 間商戶：您的首年免費期至 {{date}}。",
  "Choose a plan to activate your account.":
    "選擇方案以啟用您的帳戶。",
  "Free plan (First 100)": "免費方案（首 100）",
  "Start a chat from a student reviewing your coupon or sponsor task.":
    "如需聯絡學生，可從其優惠券或贊助任務開始對話。",
  "All Tasks": "所有任務",
  "No tasks": "沒有任務",
  "Redeem now": "立即贖回",
  Redeemed: "已贖回",
  "My Redemptions": "我的兌換記錄",
  Menu: "選單",
  "My redeemed coupons": "我已贖回的優惠券",
  "No redeemed coupons": "尚未贖回任何優惠券",
  "Redeem a coupon to see it here": "贖回優惠券後會在此顯示",
  "My redeemed sponsors": "我已贖回的贊助商",
  "No redeemed sponsors": "尚未贖回任何贊助商",
  "Redeem a sponsor to see it here": "贖回贊助商後會在此顯示",
  "This sponsor has no tasks yet.": "此贊助商暫未有任務。",
  "Sponsor activity not found": "找不到此贊助活動",
  "Please go back and try again.": "請返回後再試一次。",
  "Room name": "名稱",
  Subtitle: "簡介",
  "Redeem successful!": "贖回成功！",
  "Redeem failed. Please try again.": "贖回失敗，請再試一次。",
  "You can only redeem this sponsor once.": "你只能贖回此贊助商一次。",
  "Your Proof Code": "你的證明代碼",
  "The proof code must be clearly visible in your Instagram Story/Post. Do not reuse the same Story/Post for another sponsor.":
    "證明代碼必須清楚顯示於你的 Instagram 限時動態／貼文中。請勿將同一則限時動態／貼文重複用於其他贊助商。",
  "Instagram Post URL": "Instagram 貼文網址",
  "Instagram Post URL Required": "需要 Instagram 貼文網址",
  "Enter the Instagram post URL that shows this redemption's proof code before uploading your screenshots.":
    "上傳截圖前，請輸入顯示此兌換證明代碼的 Instagram 貼文網址。",
  "Proof Already Used": "證明已被使用",
  "These follower accounts were already used for another sponsor task: {{conflicts}}. Remove them and submit different accounts.":
    "這些追蹤者帳號已用於其他贊助任務：{{conflicts}}。請移除並提交不同的帳號。",
  "This proof has already been used for another sponsor task.":
    "此證明已用於其他贊助任務。",
  "Only {{count}} of 4 required sponsor tasks are available.":
    "僅有 {{count}} 個（共需 4 個）贊助任務可用。",
  "Select at least 4 sponsor tasks.": "請選擇至少 4 個贊助任務。",
  "Only {{count}} of 4 required sponsor tasks are available. Follow & Like Post is unavailable because {{handles}} were already used for {{sponsor}}. Please use different committee accounts.":
    "僅有 {{count}} 個（共需 4 個）贊助任務可用。「讚好及追蹤貼文」不可用，因為 {{handles}} 已用於 {{sponsor}}。請使用不同的委員會帳號。",
  "Unavailable: {{handles}} already used for {{sponsor}}.":
    "不可用：{{handles}} 已用於 {{sponsor}}。",
  "Unavailable for this redemption.": "此兌換不可用。",
  "At least 4 available sponsor tasks are required.":
    "至少需要 4 個可用的贊助任務。",
  "This proof was already used for another sponsor task: {{conflicts}}. Upload a different post or media.":
    "此證明已用於其他贊助任務：{{conflicts}}。請上傳不同的貼文或媒體。",
  "Checking...": "檢查中...",
  "Proof Code": "證明代碼",
  "Reject if the proof code is not clearly visible in the Story/Post.":
    "如證明代碼未清楚顯示於限時動態／貼文中，請拒絕。",
  "Society membership not verified yet. Please wait for a society member to approve.":
    "社團身分尚未核實，請等待社團成員審批。",
  "Can't get sponsor tasks. Please contact support.": "無法取得贊助任務，請聯絡客服。",
  "Sponsor redemption limit reached. Please try another sponsor.":
    "已達到贊助商贖回上限，請嘗試其他贊助商。",
  "Sponsor not found or has been removed.": "找不到此贊助商或已被移除。",
  "Redeem as: {{societyName}}": "以 {{societyName}} 名義贖回",
  "Fill in activity details": "填寫活動資料",
  "Activity name for sponsor": "贊助活動名稱",
  "Activity date (e.g. 2026-04-01)": "活動日期（例如 2026-04-01）",
  "Please fill in both activity name and date.": "請填寫活動名稱及日期。",
  "Please select a future date (tomorrow or later).": "請選擇未來日期（明天或之後）。",
  "Please fill in the official society Instagram account.":
    "請填寫社團官方 Instagram 帳號。",
  "Please fill in at least five committee IG accounts.":
    "請填寫至少五個幹事 Instagram 帳號。",
  "Duplicate Instagram accounts found between committee and official. Please ensure all are unique.":
    "幹事與官方 Instagram 帳號出現重複，請確保各帳號皆不相同。",
  "Official society Instagram account": "社團官方 Instagram 帳號",
  "Committee IG Accounts (at least 5)": "幹事 Instagram 帳號（至少 5 個）",
  "Add Committee Account": "新增幹事帳號",
  "Committee IG accounts are only required when redeeming as a society.":
    "幹事 Instagram 帳號只在使用社團名義贖回時才需要。",
  "Student Sponsorship Agreement": "學生贊助協議書",
  "I have read and accept the agreement above": "我已閱讀並同意上述協議",
  "By signing, you agree to the sponsor terms and conditions.":
    "簽署即表示你同意贊助條款及細則。",
  "Select your society": "選擇你的社團",
  "All Societies": "所有社團",
  "Add new society": "新增社團",
  "Register new society": "註冊新社團",
  "Confirm Society": "確認社團",
  "Send membership request to this society? A society member will review and approve.":
    "向此社團發出加入申請？社團成員將會審核並批准。",
  "Membership request sent. Please wait for a society member to approve before you can redeem as a society.":
    "已發出加入申請，請等待社團成員批准後再以社團名義贖回。",
  "Membership Request Sent": "已發出加入申請",
  "Your membership request is already under review. Please wait for a society member to approve.":
    "你的加入申請正在審核中，請等待社團成員批准。",
  "You already have a pending membership request. Please wait for approval.":
    "你已有一個待審核的加入申請，請等待批准。",
  "You have a pending membership request. Join another society after it is approved.":
    "你有待審核的加入申請，請待其批准後再加入其他社團。",
  "Failed to send membership request. Please try again.": "發送加入申請失敗，請再試一次。",
  "Failed to load societies. Please try again.": "載入社團失敗，請再試一次。",
  "Society name *": "社團名稱 *",
  "Please enter the society name.": "請輸入社團名稱。",
  "Upload HKID *": "上載香港身份證 *",
  "Upload Student Card *": "上載學生證 *",
  "Upload Society Icon (optional)": "上載社團標誌（選填）",
  "Upload Society Chop (optional)": "上載社團印章（選填）",
  "Select university": "選擇大學",
  "Instagram URL": "Instagram 網址",
  "Please upload both HKID and student card.": "請同時上載香港身份證及學生證。",
  "Tap to upload HKID": "點擊上載香港身份證",
  "Tap to upload student card": "點擊上載學生證",
  "Tap to upload icon": "點擊上載標誌",
  "Tap to upload society chop": "點擊上載印章",
  "HKID selected": "已選擇香港身份證",
  "Student card selected": "已選擇學生證",
  "Icon selected": "已選擇標誌",
  "Chop selected": "已選擇印章",
  "Society chop": "社團印章",
  "Student card": "學生證",
  Register: "註冊",
  "Society registered!": "社團註冊成功！",
  "Your society registration has been submitted for admin approval. Your membership will be reviewed by an admin. You can redeem as this society once approved.":
    "你的社團註冊已提交管理員審核，批准後即可以此社團名義贖回。",
  "Your society registration has been submitted for admin approval. You may proceed with the redemption.":
    "你的社團註冊已提交管理員審核，你可以繼續進行贖回。",
  "Failed to register society. Please try again.": "註冊社團失敗，請再試一次。",
  "Upload failed. Please try again.": "上載失敗，請再試一次。",
  "Failed to read the selected file.": "無法讀取已選檔案。",
  "Upload your documents": "上載你的證明文件",
  "Upload your HKID and student card to verify your identity before redeeming as an individual.":
    "請上載香港身份證及學生證以核實身分，然後以個人名義贖回。",
  "Please upload both your HKID and student card images.": "請同時上載香港身份證及學生證圖片。",
  "Personal verification pending. Please wait for UninfoHK to verify your documents.":
    "個人身分核實中，請等待 UninfoHK 驗證你的文件。",
  "Chat with Business": "與商家對話",
  "View Signed Agreement": "查看已簽署協議",
  "The signed agreement could not be displayed.": "無法顯示已簽署的協議。",
  "Open the agreement in a new tab": "在新分頁開啟協議",
  Deadline: "截止日期",
  "In Progress": "進行中",
  "Sponsor Task Completed": "贊助任務已完成",
  "Sponsor Tasks Failed": "贊助任務失敗",
  "You can upload proof or review your task from the activity start until the deadline. If you submit at least one proof before the deadline, you will have an extra 7-day cure period after the deadline to upload or review.":
    "你可由活動開始至截止日期期間上載證明或審核任務。如在截止日期前至少提交一份證明，截止日期後將額外獲得 7 日補救期上載或審核。",
  "Cure Period: {{start}} to {{end}} (7 days after deadline) You may upload or review your task only if you submitted proof before the deadline.":
    "補救期：{{start}} 至 {{end}}（截止日期後 7 日）只有在截止日期前提交證明，方可上載或審核任務。",
  Incomplete: "未完成",
  "Show fail reason": "查看失敗原因",
  "Upload 2 Images": "上載 2 張圖片",
  "Proof uploaded successfully!": "證明上載成功！",
  "Failed to submit proof.": "證明提交失敗。",
  "Failed to save usernames.": "用戶名稱儲存失敗。",
  "Failed to review task.": "任務審核失敗。",
  "You can upload a maximum of 2 images for this task.": "此任務最多只可上載 2 張圖片。",
  "Enter the IG usernames of the students who followed the accounts.":
    "請輸入已追蹤相關帳號的學生 IG 用戶名稱。",
  "Enter the registered username of each committee member.": "請輸入每位幹事的註冊用戶名稱。",
  "{{count}} file(s) selected": "已選擇 {{count}} 個檔案",
  "{{count}} file(s) ready to submit": "{{count}} 個檔案待提交",
  "You must upload a compensation receipt. The receipt must clearly show: - The name of the recipient - The date of payment - The name of the person paying the compensation":
    "你必須上載補償收據。收據必須清楚顯示：- 收款人姓名 - 付款日期 - 支付補償人士的姓名",
  Language: "語言",
  "Grow your brand on campus": "在校園拓展你的品牌",
  "Reach a real student audience — every account is tied to a verified university email.":
    "接觸真正的學生群體——每個帳戶均與已驗證的大學電郵綁定。",
  "Feature your events and workshops on the calendar students already browse every day.":
    "讓你的活動及工作坊登上學生每日瀏覽的行事曆。",
  "Reward students with coupons they redeem with points, and sponsor society events too.":
    "以積分可兌換的優惠券回饋學生，亦可贊助社團活動。",
  "Run activities with real-time QR check-in and get instant, verified attendance.":
    "以即時QR簽到舉辦活動，瞬間取得已核實的出席數據。",
  "Message interested students in real time and keep the conversation going.":
    "即時與有興趣的學生對話，延續每個機會。",
  "The pros of partnering with us": "與我們合作的優勢",
  "Built-in tools make it easy to get your brand in front of the student community":
    "內建工具讓你的品牌更容易接觸學生社群",
  "Connect with students and societies across Hong Kong's universities":
    "接觸全港各大學的學生與學會",
  "Create activities students can join": "舉辦活動讓學生參與",
  "First 100 businesses free for 1 year": "首100間商戶首年免費",
  "Join free for your first year — limited to the first 100 businesses":
    "首年免費加入，名額只限首100間商戶",
  "Post events and activities that students can join directly on the platform":
    "發佈活動，讓學生直接在平台報名參與",
  "Promote your brand to students — easily": "輕鬆向學生推廣你的品牌",
  "Reach the university community": "觸及大學社群",
  "Free to join": "免費加入",
  "Join as a partner with no upfront cost.": "成為合作夥伴，無需前期成本。",
  "What you can do to reach students": "你可以如何接觸學生",
  "Publish coupons": "發佈優惠券",
  "Create redeemable coupons students earn with points.":
    "建立學生可憑積分兌換的優惠券。",
  "Host events & workshops": "舉辦活動與工作坊",
  "List your activities on the student calendar.":
    "在學生日曆上列出你的活動。",
  "Sponsor societies": "贊助學會",
  "Fund society events to put your brand in front of engaged members.":
    "贊助學會活動，讓你的品牌接觸活躍會員。",
  "What we do to help you reach students & societies":
    "我們如何助你接觸學生與學會",
  "Connect you with the university community": "為你連繫大學社群",
  "Coupons, events and sponsorships get your brand noticed by students":
    "透過優惠券、活動與贊助，讓學生更容易留意你的品牌",
  "Promote your brand to the community": "向社群推廣你的品牌",
  "Put your activities in front of students": "讓學生看到你的活動",
  "See activities, redemptions and messages in one partner dashboard":
    "在合作夥伴儀表板查看活動、兌換與訊息",
  "Track everything in one dashboard": "一站式儀表板追蹤成效",
  "We bring your brand into a community of students and societies across Hong Kong universities":
    "我們讓你的品牌接觸全港大學的學生與學會社群",
  "Your events and activities are listed on the student calendar for easy joining":
    "你的活動會出現在學生日曆上，方便學生報名參與",
  "Society network": "學會網絡",
  "We connect you with the right societies across universities.":
    "我們為你連繫各大學的合適學會。",
  "Three steps to become a partner": "三步成為合作夥伴",
  Apply: "申請加入",
  "Tell us about your business and the students you want to reach.":
    "告訴我們你的業務，以及你想接觸的學生群體。",
  "Set up your offers": "設定你的優惠",
  "Publish coupons, events and activities from your partner dashboard.":
    "在合作夥伴後台發佈優惠券、活動及工作坊。",
  "Grow your reach": "擴大觸及範圍",
  "Track redemptions, attendance and messages in one partner dashboard.":
    "於同一個合作夥伴後台追蹤兌換、出席及訊息。",
  "Ready to grow with Uninfo HK?": "準備好與Uninfo HK一起成長了嗎？",
  "Uninfo HK": "Uninfo HK",
  "Show password": "顯示密碼",
  "Hide password": "隱藏密碼",
  "Student Verification": "學生身分核實",
  "Not Verified": "未核實",
  "Pending approval": "待審批",
  "Upload Student Card": "上載學生證",
  "Upload HKID": "上載香港身份證",
  "Upload Documents": "上載證明文件",
  "Your identity has been verified.": "你的身分已核實。",
  "Your documents are being reviewed by an admin.":
    "你的文件正由管理員審核中。",
  "Verify your identity to redeem coupons, sponsors and join activities.":
    "核實身分後即可兌換優惠券、贊助並參加活動。",
  "Upload your HKID (Optional)": "上傳你的香港身份證（可選）",
  "Uninfo will verify your HKID in 24 hrs": "Uninfo會在24小時內驗證你的香港身份證",
  "Upload your HKID to redeem coupons and sponsors.":
    "請上載你的香港身份證以兌換優惠券及贊助。",
  "Upload your student card to join activities and redeem.":
    "請上載你的學生證以參加活動及兌換。",
  "Please upload at least one document.": "請至少上載一份文件。",
  "Student has not uploaded HKID": "學生未有上載香港身份證",
  "Student has not uploaded student card": "學生未有上載學生證",
  "Upload the front of your student card. Once approved, you can join activities and events.":
    "上載你學生證的正面。驗證通過後，你便可參加活動。",
  "Upload the front of your Hong Kong Identity Card. Needed to redeem coupons and sponsor offers (with an approved student card).":
    "上載你香港身份證的正面。連同已驗證的學生證，便可兌換優惠券及贊助優惠。",
  "This document is already on file and cannot be replaced.":
    "此文件已存檔，不能重新上載。",
  Product: "產品",
  "Max participants": "參加者上限",
  "Not available": "暫時未能提供",
  "Please fill in a whole number of participants between 1 and {{max}}.":
    "請填寫 1 至 {{max}} 之間的整數參加者人數。",
  "Missing or invalid participants quantity.": "缺少或無效的參加者人數。",
  "Participants quantity is out of range.": "參加者人數超出範圍。",
  "Redemption quantity is invalid.": "無效的贖回數量。",
  "Something went wrong on our side. Please try again.": "伺服器發生問題，請再試一次。",
  "All categories": "所有分類",
  "No sponsors in this category": "此分類沒有贊助商",
  "Choose quantity": "選擇數量",
  "Max quantity": "最高數量",
  "Quantity (packs as priced)": "數量（以原包計）",
  "You can claim up to {{maxQuantity}} for {{participants}} participants.":
    "你可為最多 {{participants}} 位參加者領取最多 {{maxQuantity}}。",
  "Could not load the sponsor obligations. Please try again.":
    "無法載入贊助義務，請再試一次。",
  "Redemption quantity is invalid": "兌換數量無效",
  
  "You are not a member of any society yet — join one to redeem as a society.": "你尚未成為任何社團的會員 — 請先加入一個社團以社團身份兌換。",
  Member: "會員",
  "Decrease quantity": "減少數量",
  "Increase quantity": "增加數量",
  "Showing {{from}}–{{to}} of {{total}}": "顯示第 {{from}}–{{to}} 項，共 {{total}} 項",
  "Previous page": "上一頁",
  "Next page": "下一頁",
  "Page {{page}} of {{total}}": "第 {{page}} 頁，共 {{total}} 頁",
  // Admin console login
  "Administration, in one place.": "管理作業，一站掌握。",
  "Review students, societies and sponsors across the Uninfo platform.":
    "於 Uninfo 平台審核學生、社團及贊助商。",
  "Authorised administrators only.": "只供獲授權的管理員使用。",
  "Signing in...": "登入中…",
  "Admin Not Found or Inactive": "管理員不存在或已停用",
  "Admin Invalid Password": "管理員密碼不正確",
  "Admin Account Is Not Active": "管理員帳戶未啟用",
  "Upload society chop": "上傳學會印章",
  "Replace society chop": "更換學會印章",
  "A society chop is required to finalize": "必須上傳學會印章才可完成簽署",
  "Failed to generate the signed agreement. Please try again.":
    "無法產生簽署文件，請再試一次。",
  Accept: "接受",
  Accepted: "已接受",
  Activities: "活動",
  "Activities will appear here.": "活動將顯示於此。",
  "Activities you create will appear here.": "你建立的活動將顯示於此。",
  "Activities you join will appear here.": "你加入的活動將顯示於此。",
  "Browse activities": "瀏覽活動",
  "Discover activities, join in and manage the ones you create.":
    "探索活動、參加活動，並管理你建立的活動。",
  "Organizer unavailable": "主辦方暫不可用",
  "This activity is unavailable because the organizer is not active.":
    "此活動暫不可用，因為主辦方目前並非有效狀態。",
  "Activity ended": "活動已結束",
  "Applications closed": "截止報名",
  "Full": "名額已滿",
  "This activity has already taken place.": "此活動已經結束。",
  "The application deadline has passed.": "報名截止日期已過。",
  "This activity is full.": "此活動名額已滿。",
  "View details": "查看詳情",
  "Are you sure you want to delete this activity?": "確定要刪除此活動嗎？",
  "Deadline Date": "截止日期",
  "Deadline Time": "截止時間",
  Details: "詳情",
  HashTags: "標籤",
  "Joining...": "加入中…",
  "Load More": "載入更多",
  "Meeting Date": "集合日期",
  "Meeting Date & Time": "集合日期及時間",
  "Meeting Time": "集合時間",
  "No activities yet": "暫無活動",
  Category: "類別",
  "Select a category": "選擇類別",
  "ActivityCategory.Sports": "運動",
  "ActivityCategory.Outdoors": "戶外",
  "ActivityCategory.FoodDrink": "飲食",
  "ActivityCategory.Study": "學習",
  "ActivityCategory.Games": "遊戲",
  "ActivityCategory.BoardGame": "桌上遊戲",
  "ActivityCategory.Social": "社交",
  "ActivityCategory.ArtsCulture": "藝術文化",
  "ActivityCategory.Music": "音樂",
  "ActivityCategory.Wellness": "健康養生",
  "ActivityCategory.Technology": "科技",
  "ActivityCategory.Volunteering": "義工",
  "ActivityCategory.Other": "其他",
  "No participants yet": "暫無參加者",
  "Pull to refresh to load activities.": "下拉刷新以載入活動。",
  "signup.businessEmailExisted": "商戶電郵已存在",
  "Business Registration No.": "商業登記號碼",
  "Business Registration Certificate": "商業登記證",
  "Business Details": "商戶資料",
  "Create Business Account": "建立商戶帳戶",
  "Please upload your business registration certificate": "請上載商業登記證",
  Photo: "相片",
  Continue: "繼續",
  Plan: "方案",
  "Choose your plan": "選擇您的方案",
  "planDiscount.badge": "節省約 {{percent}}%",
  "planDiscount.savings": "每年節省 HKD {{amount}} · 免費 2 個月",
  "First 100 businesses get their first year free. Eligibility is confirmed after sign-up.":
    "首 100 間商戶可享首年免費，資格將於註冊後確認。",
  "I have read and accept the": "我已閱讀並接受",
  "Business Terms & Conditions": "商戶條款及細則",
  "Please accept the Business Terms & Conditions": "請接受商戶條款及細則",
  "Your registration is approved. Complete your subscription to activate your account.":
    "您的註冊已獲批准。請完成訂閱以啟用您的帳戶。",
  "businessTerms.lastUpdated": "最後更新：2026 年 11 月",
  "businessTerms.intro":
    "本《商戶條款及細則》（「本條款」）規管您以商戶身分使用 Uninfo HK 平台。當您註冊商戶帳戶、選擇訂閱方案並接受本條款，即表示您同意受本條款約束。如您不同意，請勿註冊或使用商戶服務。",
  "businessTerms.acceptance.title": "1. 條款的接納",
  "businessTerms.acceptance.p1":
    "當您建立商戶帳戶，即確認您已閱讀、理解並接受本條款，以及我們的一般《服務條款》及《私隱政策》。",
  "businessTerms.acceptance.p2":
    "您須於註冊時接受本條款。Uninfo HK 會記錄您的接受情況及所接受的條款版本。",
  "businessTerms.eligibility.title": "2. 資格及商戶帳戶",
  "businessTerms.eligibility.p1":
    "您須為於香港正式註冊（或合法經營）的商戶，並提供準確、最新及完整的資料，包括有效的商業登記（BR）號碼及證書。",
  "businessTerms.eligibility.p2":
    "您聲明並保證您有權代表該商戶接受本條款，且所提交的一切資料均屬真實、準確且無誤導。我們可核實您的資料，並可全權自行決定批准、拒絕、限制或暫停任何商戶帳戶，且無須承擔責任。",
  "businessTerms.fees.title": "3. 訂閱方案及費用",
  "businessTerms.fees.p1":
    "Uninfo HK 提供年繳方案，每年港幣 500 元（價格以港幣計）。",
  "businessTerms.fees.p2":
    "除另有註明外，訂閱會於每個年繳計費週期結束時，按年繳方案的現行價格自動續期，直至您按本條款取消為止。Uninfo HK 可隨時更改費用或方案價格；有關更改於平台上公佈或通知您時生效，而您在費用更改後繼續使用商戶服務，即構成對新費用的接受。",
  "businessTerms.payment.title": "4. 付款及信用卡授權",
  "businessTerms.payment.p1":
    "付款由我們的第三方支付服務供應商 Stripe 處理。當您提供信用卡資料，即授權 Stripe 收取適用的訂閱費用及任何適用稅項。",
  "businessTerms.payment.p2":
    "Uninfo HK 不會儲存您的完整信用卡資料；信用卡資料由 Stripe 按其自身條款處理。您須確保存檔的付款資料有效且最新，並授權於每個續期週期開始時自動收費，直至您取消為止。在取消生效前所產生的一切費用及收費，仍由您負責。",
  "businessTerms.coupon.title": "5. 每月最低優惠券要求、優惠券及活動專營",
  "businessTerms.coupon.p1":
    "作為訂閱條件之一，您於商戶帳戶生效期間的每個曆月，須於平台上發佈至少一（1）張新的優惠券。",
  "businessTerms.coupon.p2":
    "「優惠券」指您在平台上提供兌換的任何優惠、折扣、現金券、交易或推廣。優惠券僅在其未曾於平台上發佈，且並非同時於其他地方提供時，方計為「新」優惠券。",
  "businessTerms.coupon.p3":
    "優惠券專營。您在平台上發佈的每張優惠券，必須獨家透過 Uninfo HK 提供。當優惠券在平台上生效期間（以及 Uninfo HK 推廣該優惠券的任何期間），您不得在任何其他平台、市場、網站、應用程式、社交媒體渠道或實體店舖，以相同或不同價格發佈、宣傳、列示或以其他方式提供同一優惠券，或任何實質上相似的優惠券、優惠或折扣。您不得為符合每月要求而發佈、重新發佈、循環再用或改頭換面地重用過往提供的優惠券。",
  "businessTerms.coupon.p4":
    "活動專營。您在平台上發佈的每項活動、事件、推廣或其他要約（每項稱為「活動」），必須獨家透過 Uninfo HK 提供。當活動在平台上生效期間（以及 Uninfo HK 推廣該活動的任何期間），您不得在任何其他平台、市場、網站、應用程式、社交媒體渠道或實體店舖，以免費或相同或不同價格發佈、宣傳、列示或以其他方式提供同一活動，或任何實質上相似的活動。您不得為符合本條款下的任何要求而發佈、重新發佈、循環再用或改頭換面地重用過往提供的活動。",
  "businessTerms.coupon.p5":
    "僅限學生受眾。您在平台上發佈的每張優惠券及每項活動，必須僅提供予 Uninfo HK 的已驗證大學學生用戶。您不得透過任何其他渠道，以相同或不同價格，向公眾或任何非學生受眾提供同一優惠券或活動，或任何實質上相似的優惠券或活動。Uninfo HK 可要求於兌換前提供學生驗證證明，並可拒絕、移除、暫停或終止任何向非學生提供的優惠券或活動。",
  "businessTerms.coupon.p6":
    "未能符合每月最低要求，或違反上述任何專營或僅限學生受眾的義務，即構成對本條款的重大違反。Uninfo HK 可全權自行決定就每個未達最低要求或違反該等義務的曆月向您收取額外 HKD 100 的費用，並可暫停或終止您的帳戶及商戶服務、扣起相關功能，及拒絕為您的訂閱續期，而已收取的費用概不退還。",
  "businessTerms.cancellation.title": "6. 取消、退款及不設退款政策",
  "businessTerms.cancellation.p1":
    "您僅可於訂閱首個年度結束後取消訂閱。您可透過您的帳戶或聯絡我們提出取消申請，取消於您已付費週期結束時生效，其後將不再續期。",
  "businessTerms.cancellation.p2":
    "所有已收取的費用概不退還。我們不會就未使用的部分週期、未使用的功能、未發佈的優惠券或您未使用的帳戶提供退款或積分，且取消並未免除您就任何已到期費用的責任。",
  "businessTerms.cancellation.p3":
    "信用卡有效性及持續責任。您必須確保存檔的付款方式有效。如您的付款方式過期、被更換、被拒付，或出現其他無效情況，我們可暫停或限制您帳戶的功能。暫停並不會取消您的訂閱，亦不免除您的費用責任：在您取消日期前所累積的所有平台費用及任何優惠券差額費用，仍由您負責，包括在首年免費期內亦然。您必須及時更新您的付款方式；未繳款項可在您提供有效付款方式後收取。",
  "businessTerms.latePayment.title": "7. 付款失敗或逾期、退款爭議及帳戶暫停",
  "businessTerms.latePayment.p1":
    "如付款失敗、逾期或被撤回（包括退款爭議或付款糾紛），我們可重新嘗試收費，並即時暫停或限制您的帳戶及商戶功能，直至成功付款為止。您仍須負責繳付所有應付費用，以及我們為追討該等費用而產生的任何成本及合理行政費用。",
  "businessTerms.obligations.title": "8. 商戶責任及禁止內容",
  "businessTerms.obligations.p1":
    "您同意與 Uninfo HK 及其用戶合法並真誠地交易，並會兌現您在平台上宣傳的一切優惠、優惠券、折扣、活動及兌換承諾。您必須確保每張優惠券及每項活動均獨家透過 Uninfo HK 提供，並僅提供予已驗證大學學生用戶。",
  "businessTerms.obligations.p2":
    "您不得發佈違法、誤導、侵權、冒犯或禁止的內容，亦不得濫用平台、試圖規避費用或干擾平台運作。您須就您的產品、服務、優惠及遵守一切適用法律獨自負責。",
  "businessTerms.listings.title": "9. 商戶資訊、內容及授權",
  "businessTerms.listings.p1":
    "您授予 Uninfo HK 一項非專屬、全球性、免版稅的許可，僅為營運及推廣平台之目的，展示、複製及推廣您提交的商戶名稱、標誌、優惠、圖像及其他內容。您聲明您擁有或有權使用該等內容。Uninfo HK 可全權自行決定拒絕、移除或編輯任何資訊或內容，且無須通知。本內容授權就您的內容而言屬非專屬；此並不限制第 5 條下的優惠券及活動專營及僅限學生受眾義務，即您發佈的每張優惠券及每項活動必須獨家透過 Uninfo HK 提供，並僅提供予已驗證大學學生。",
  "businessTerms.platformRole.title": "10. 平台角色、不設保證及不設擔保",
  "businessTerms.platformRole.p1":
    "Uninfo HK 是一個連接商戶與學生及其他用戶的平台。平台按「現狀」及「現有」基準提供。我們不保證服務不會中斷、安全或無誤，亦不保證任何最低的學生參與度、兌換量、流量、收入或成效。您使用平台的一切風險由您自行承擔。",
  "businessTerms.liability.title": "11. 責任限制",
  "businessTerms.liability.p1":
    "在法律允許的最大範圍內，Uninfo HK 不就任何間接、附帶、特殊、後果性或懲罰性損害，或任何利潤、收入、資料、商譽或機會損失承擔責任。我們對您的總責任上限為港幣 100 元或您在引起申索事件前緊接一（1）個月內向 Uninfo HK 支付的費用（以較高者為準）。我們不就學生或其他用戶的行為，或您或任何第三方提供的任何優惠、產品或服務承擔責任。",
  "businessTerms.indemnity.title": "12. 彌償",
  "businessTerms.indemnity.p1":
    "您同意就因您的業務、您的優惠、產品或服務、您的內容或您違反本條款而引致的任何申索、損失、責任、損害、費用及開支（包括法律費用），向 Uninfo HK 及其關聯公司、人員、僱員及代理人作出彌償、抗辯並使其免受損害。",
  "businessTerms.termination.title": "13. Uninfo HK 的終止及暫停",
  "businessTerms.termination.p1":
    "如您違反本條款、未繳付任何費用、未能符合每月最低優惠券要求、違反優惠券或活動專營或僅限學生受眾義務、濫用平台、法律要求，或我們合理認為您繼續使用可能損害平台或其用戶，我們可在發出或不發出通知的情況下暫停或終止您的商戶帳戶或平台使用權。除法律要求外，已付費用不設退款。",
  "businessTerms.changes.title": "14. 條款變更、修改及終止服務",
  "businessTerms.changes.p1":
    "我們可隨時更新本條款，並可隨時修改、暫停或終止平台或任何功能，且無須承擔責任。本條款的重大變更將於本頁公佈並註明新版本日期，而變更生效後您繼續使用平台，即構成對更新後條款的接受。",
  "businessTerms.general.title": "15. 一般條款",
  "businessTerms.general.p1":
    "您須獨自負責取得及維持您業務所需的一切牌照、許可及批准，並負責繳付由此產生的一切稅項。本條款並不構成您與 Uninfo HK 之間的任何代理、合夥、僱傭或合資關係。我們可在無須您同意的情況下轉讓或轉移本條款。如任何條文被裁定不可執行，其餘條文仍具完全效力。本條款（連同我們的一般《服務條款》及《私隱政策》）構成您與 Uninfo HK 就商戶服務的完整協議。",
  "businessTerms.governingLaw.title": "16. 管轄法律及司法管轄權",
  "businessTerms.governingLaw.p1":
    "本條款受香港特別行政區法律管轄。您同意接受香港法院的專屬司法管轄權管轄。",
  "businessTerms.contact.title": "17. 聯絡我們",
  "businessTerms.contact.p1":
    "如對本條款有任何疑問，請透過我們的聯絡頁面與我們聯絡。",
  "Continue to card": "繼續付款",
  "Get started free": "免費開始",
  "Subscribe now": "立即訂閱",
  "Card validated": "已驗證信用卡",
  "Finalising registration…": "正在完成註冊…",
  "Update card": "更新信用卡",
  "Your payment method is invalid. Please update your card.":
    "您的付款方式無效，請更新您的信用卡。",
  "Card updated": "信用卡已更新",
  "Card valid": "信用卡有效",
  "Card invalid": "信用卡無效",
  "No card on file": "沒有已儲存的信用卡",
  "First 100 · free year": "首 100 名 · 首年免費",
  "Not in First 100": "非首 100 名",
  "Payment failed": "付款失敗",
  "Card removed": "信用卡已移除",
  "Card expired": "信用卡已過期",
  Status: "狀態",
  "Account status": "帳戶狀態",
  "Activate business": "啟用商戶",
  "Deactivate business": "停用商戶",
  "Renews on": "續期日",
  "Ends on": "結束日",
  "Free trial ends": "免費試用結束",
  "No subscription": "沒有訂閱",
  "Resume subscription": "恢復訂閱",
  "Cancel subscription": "取消訂閱",
  "Manage in Stripe": "在 Stripe 管理",
  "Minimum term": "最低合約期",
  "Cancel at": "取消於",
  Access: "存取權",
  "Terminated instantly": "即時終止",
  Trialing: "試用中",
  "Past due": "逾期",
  Cancelled: "已取消",
  "No plan": "沒有方案",
  "Subscription terminated": "訂閱已終止",
  Reactivate: "重新啟用",
  "Business reactivated. The business can now choose a plan and re-subscribe.":
    "商戶已重新啟用，現可重新選擇方案並訂閱。",
  "Activate this business?": "啟用此商戶？",
  "The business will be able to sign in and use the platform again.":
    "商戶將可重新登入並使用平台功能。",
  "Deactivate this business?": "停用此商戶？",
  "The business will be logged out and cannot sign in until it is activated again.":
    "商戶將被登出，在重新啟用前無法登入。",
  Activate: "啟用",
  Deactivate: "停用",
  "Reactivate this business?": "重新啟用此商戶？",
  "The subscription is reset so the business can choose a plan and re-subscribe. The saved card and promo stay on file.":
    "訂閱將會重設，商戶可重新選擇方案並訂閱。已儲存的信用卡及優惠將予保留。",
  "Cancel this subscription?": "取消此訂閱？",
  "Resume this subscription?": "恢復此訂閱？",
  "Auto-renewal is re-enabled and the business keeps its current period.":
    "將重新啟用自動續訂，商戶可繼續現有週期。",
  "Manage in Stripe?": "在 Stripe 中管理？",
  "Open the Stripe Billing Portal in a new tab to update the card or manage the subscription.":
    "將在新分頁開啟 Stripe 付款後台，以更新信用卡或管理訂閱。",
  Open: "開啟",
  "Approve this business?": "批核此商戶？",
  "Only the login flag changes. The subscription keeps running in Stripe, so renewals, platform fees and late fees are unaffected.":
    "只會變更登入旗標。訂閱仍會在 Stripe 繼續運作，續費、平台費用及逾期費用均不受影響。",
  "Only the login flag changes. Subscription status and access stay exactly as they are.":
    "只會變更登入旗標。訂閱狀態及使用權限維持不變。",
  "The ended subscription is dropped, access unlocks right away and status becomes No plan. The original 12-month minimum term still applies.":
    "已結束的訂閱將會移除，使用權限即時解鎖，狀態變為沒有方案。原本的 12 個月最低合約期仍然適用。",
  "Only the scheduled cancellation is cleared. Nothing is charged now and the price does not change.":
    "只會清除已排程的取消設定。現在不會扣款，價格亦不會改變。",
  "This schedules the cancellation, it does not end the subscription now. The business keeps every paid feature and is still billed until the date above; only afterwards does Stripe end it and terminate access.":
    "此操作只是排程取消，並非即時結束訂閱。商戶在上述日期前仍享有所有已付功能並會繼續計費；到期後 Stripe 才會結束訂閱並終止使用權限。",
  "This opens Stripe in another tab. Nothing in Uninfo changes until an update is made inside Stripe.":
    "此操作會在另一分頁開啟 Stripe。在 Stripe 內作出更新前，Uninfo 內不會有任何變更。",
  "The business is allowed to publish coupons, sponsors and activities. Billing still depends on having an active subscription.":
    "商戶將獲准發佈優惠券、贊助商及活動。計費仍取決於有效的訂閱。",
  "Profile details": "商戶資料",
  "The account flag only controls sign-in. Billing is managed in the Subscription section below.":
    "帳戶旗標只控制能否登入。計費由下方的「訂閱」部分管理。",
  "Terminated instantly: the subscription ended, so all paid features are blocked. Use Reactivate to let the business choose a plan again.":
    "即時終止：訂閱已結束，所有已付功能已被封鎖。請使用「重新啟用」讓商戶重新選擇方案。",
  "I have read and agree to the Student Terms & Conditions and Privacy Policy": "我已閱讀並同意《學生條款及細則》及《私隱政策》",
  "Student Terms & Conditions": "學生條款及細則",
  "Please accept the Student Terms & Conditions and Privacy Policy": "請同意《學生條款及細則》及《私隱政策》",
  'Filter by date': '按日期篩選',
  'Filter by location': '按地點篩選',
  'Filter by hashtag': '按標籤篩選',
  'Any date': '任何日期',
  'Upcoming': '即將舉行',
  'Next 7 days': '未來 7 天',
  'Next 30 days': '未來 30 天',
  'Past': '已結束',
  'Hashtag': '標籤',
  'Any location': '任何地點',
  'Any hashtag': '任何標籤',
  'Applications open only': '只顯示接受報名',
}
